import { c as contentWindow } from "./index-B_Js14B5.js";
import { b } from "./index-B_Js14B5.js";
import handlebars from "handlebars";
const formatCurrency = (value) => {
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) {
    throw new Error("Not a number");
  }
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2
  }).format(num);
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var numberToWords_min = { exports: {} };
/*!
 * Number-To-Words util
 * @version v1.2.4
 * @link https://github.com/marlun78/number-to-words
 * @author Martin Eneqvist (https://github.com/marlun78)
 * @contributors Aleksey Pilyugin (https://github.com/pilyugin),Jeremiah Hall (https://github.com/jeremiahrhall),Adriano Melo (https://github.com/adrianomelo),dmrzn (https://github.com/dmrzn)
 * @license MIT
 */
var hasRequiredNumberToWords_min;
function requireNumberToWords_min() {
  if (hasRequiredNumberToWords_min) return numberToWords_min.exports;
  hasRequiredNumberToWords_min = 1;
  (function(module, exports) {
    !function() {
      var t = 9007199254740991;
      function f(e) {
        return !("number" != typeof e || e != e || e === 1 / 0 || e === -1 / 0);
      }
      function l(e) {
        return "number" == typeof e && Math.abs(e) <= t;
      }
      var n = /(hundred|thousand|(m|b|tr|quadr)illion)$/, r = /teen$/, o = /y$/, i = /(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/, s = { zero: "zeroth", one: "first", two: "second", three: "third", four: "fourth", five: "fifth", six: "sixth", seven: "seventh", eight: "eighth", nine: "ninth", ten: "tenth", eleven: "eleventh", twelve: "twelfth" };
      function h(e) {
        return n.test(e) || r.test(e) ? e + "th" : o.test(e) ? e.replace(o, "ieth") : i.test(e) ? e.replace(i, a) : e;
      }
      function a(e, t2) {
        return s[t2];
      }
      var u = 10, d = 100, p = 1e3, v = 1e6, b2 = 1e9, y = 1e12, c = 1e15, g = 9007199254740992, m = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"], w = ["zero", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
      function x(e, t2) {
        var n2, r2 = parseInt(e, 10);
        if (!f(r2)) throw new TypeError("Not a finite number: " + e + " (" + typeof e + ")");
        if (!l(r2)) throw new RangeError("Input is not a safe number, it’s either too large or too small.");
        return n2 = function e2(t3) {
          var n3, r3, o2 = arguments[1];
          if (0 === t3) return o2 ? o2.join(" ").replace(/,$/, "") : "zero";
          o2 || (o2 = []);
          t3 < 0 && (o2.push("minus"), t3 = Math.abs(t3));
          t3 < 20 ? (n3 = 0, r3 = m[t3]) : t3 < d ? (n3 = t3 % u, r3 = w[Math.floor(t3 / u)], n3 && (r3 += "-" + m[n3], n3 = 0)) : t3 < p ? (n3 = t3 % d, r3 = e2(Math.floor(t3 / d)) + " hundred") : t3 < v ? (n3 = t3 % p, r3 = e2(Math.floor(t3 / p)) + " thousand,") : t3 < b2 ? (n3 = t3 % v, r3 = e2(Math.floor(t3 / v)) + " million,") : t3 < y ? (n3 = t3 % b2, r3 = e2(Math.floor(t3 / b2)) + " billion,") : t3 < c ? (n3 = t3 % y, r3 = e2(Math.floor(t3 / y)) + " trillion,") : t3 <= g && (n3 = t3 % c, r3 = e2(Math.floor(t3 / c)) + " quadrillion,");
          o2.push(r3);
          return e2(n3, o2);
        }(r2), t2 ? h(n2) : n2;
      }
      var M = { toOrdinal: function(e) {
        var t2 = parseInt(e, 10);
        if (!f(t2)) throw new TypeError("Not a finite number: " + e + " (" + typeof e + ")");
        if (!l(t2)) throw new RangeError("Input is not a safe number, it’s either too large or too small.");
        var n2 = String(t2), r2 = Math.abs(t2 % 100), o2 = 11 <= r2 && r2 <= 13, i2 = n2.charAt(n2.length - 1);
        return n2 + (o2 ? "th" : "1" === i2 ? "st" : "2" === i2 ? "nd" : "3" === i2 ? "rd" : "th");
      }, toWords: x, toWordsOrdinal: function(e) {
        return h(x(e));
      } };
      module.exports && (exports = module.exports = M), exports.numberToWords = M;
    }();
  })(numberToWords_min, numberToWords_min.exports);
  return numberToWords_min.exports;
}
var numberToWords_minExports = requireNumberToWords_min();
const converter = /* @__PURE__ */ getDefaultExportFromCjs(numberToWords_minExports);
const formatAddress = (address) => {
  return `${(address == null ? void 0 : address.street) ?? ""} ${(address == null ? void 0 : address.city) ?? ""} ${(address == null ? void 0 : address.state) ?? ""} ${(address == null ? void 0 : address.country) ?? ""} ${(address == null ? void 0 : address.postCode) ?? ""}`;
};
const formatDate$2 = (date) => {
  return new Date(date).toLocaleDateString("en-AU");
};
const CreditContractTemplate = ({
  borrowerFirstName,
  borrowerMiddleName,
  borrowerLastName,
  borrowerAddress,
  merchantStoreName,
  loanAmount,
  interestRatePercentage,
  interestFreeMonths,
  originationFee,
  interestFreeRepaymentsAmount,
  interestBearingRepaymentsAmount,
  paymentFrequency,
  totalInterest,
  numberOfRepayments,
  totalCustomerCost,
  totalAccountFees,
  accountKeepingFee,
  loanPurpose,
  applicationDecisionDate,
  includeResizerScript
}) => {
  const hasPromotionalPeriod = !!interestFreeMonths;
  const isMonthlyPaymentFrequency = paymentFrequency === "monthly";
  const resizerScript = includeResizerScript ? `
      <script
         type="text/javascript"
      >${contentWindow}<\/script>
   ` : "";
  return `<!DOCTYPE html>
<html>
   <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet">
      ${resizerScript}
      <style>
         body {
         font-family: Verdana, sans-serif;
         padding: 16px;
         }
         .font-small {
         font-size: small;
         }
         .italic {
         font-style: italic;
         }
         /* Ordered List Styles */
         ol {
         counter-reset: item;
         }
         ol li {
         display: block;
         position: relative;
         margin-bottom: 10px;
         }
         ol > li::before {
         content: counters(item, ".") ".";
         counter-increment: item;
         position: absolute;
         right: 10px;
         margin-right: 100%;
         }
         /* Lower Roman Numerals */
         ol.lower-roman {
         counter-reset: lritem;
         }
         ol.lower-roman > li:before {
         content: "(" counter(lritem, lower-roman) ") ";
         counter-increment: lritem;
         }
         /* Lowercase Alphabetic Letters */
         ol.lower-alpha {
         counter-reset: laitem;
         }
         ol.lower-alpha > li:before {
         content: "(" counter(laitem, lower-alpha) ") ";
         counter-increment: laitem;
         }
         /* Grey Box Styles */
         div.grey-box {
         border-style: solid;
         padding: 10px;
         background-color: lightgray;
         }
         /* Unordered List Styles */
         ul li {
         list-style: disc outside none;
         display: list-item;
         }
         ul.circle li {
         list-style: circle outside none;
         display: list-item;
         }
         /* Table */
         table {
         border-collapse: collapse;
         }
         th,
         td {
         border: 1px solid black;
         padding: 5px;
         vertical-align: top;
         }
         .capitalize {
         text-transform: capitalize;
         }
         .underline {
         text-decoration: underline;
         }
         .text-center {
         text-align: center;
         }
      </style>
   </head>
   <body>
      <div>
         <!-- Header-->
         <div align="center">
            <span style="font-size: 15px;">Navalo Financial Services Group Pty Ltd</span>
            <br />
            <span style="font-size: 20px;">
            <strong>PayrightPlus Loan Contract</strong>
            </span>
            <br />
            <span>
            ACN 605 753 535
            </span>
            <br />
            <span>
            Australian Credit Licence Number 533485
            </span>
            <br />
         </div>
         <br />
         <!--Credit contract-->
         <div style="background-color: lightgrey; padding: 8px;">
            <strong>Credit Contract</strong>
            <p>
               <strong>Lender:</strong>
               Navalo Financial Services Group Pty Ltd ACN 605 753 535, Australian Credit Licence 533485 of Level 16, 1 Martin Place, Sydney, NSW 2000 as agent for Devizo Finance Pty Ltd.
               <strong>
               (us/we/our)
               </strong>
            </p>
            <p>
               <strong>Borrower:</strong>
               <a></a>
               <a>
               ${borrowerFirstName ?? ""} ${borrowerMiddleName ?? ""} ${borrowerLastName ?? ""}
               <strong>(you/your)</strong> of ${formatAddress(borrowerAddress)}
               </a>
            </p>
         </div>
         <br />
         <!--Financial table-->
         <p>
            <strong>Financial Table</strong>
         </p>
         <p>
            The following information is prepared as at ${formatDate$2(
    applicationDecisionDate
  )} (<em>disclosure date</em>). This information may change.
         </p>
         <!-- start of Financial table -->
         <table>
            <tr>
               <td>
                  <strong>The maximum <i>amount of credit</i> we may lend you in relation to this loan</strong>
               </td>
               <td>${formatCurrency(loanAmount)}</td>
            </tr>
            ${hasPromotionalPeriod ? `
            <tr>
               <td>Promotional interest rate applicable for the first ${interestFreeMonths} months</td>
               <td>0% per annum</td>
            </tr>
            <tr>
               <td>Interest rate applicable applicable after the first ${interestFreeMonths} months</td>
               <td>${interestRatePercentage}% per annum</td>
            </tr>
            ` : `
            <tr>
               <td>Standard interest rate</td>
               <td>${interestRatePercentage}% per annum</td>
            </tr>
            `}
            <tr>
               <td>Default Rate</td>
               <td>0% per annum</td>
            </tr>
            <tr>
               <td>Total interest payable</td>
               <td>${formatCurrency(totalInterest)} ${hasPromotionalPeriod ? `with ${interestFreeMonths} months promotional period` : "with no promotional period"}
               </td>
            </tr>
            <tr>
               <td colspan="2">
                  <strong>Repayments</strong>
               </td>
            </tr>
            ${hasPromotionalPeriod ? `
            <tr>
               <td>(i) During the first ${converter.toWords(
    interestFreeMonths
  )} (${interestFreeMonths}) months, your Repayment Amount will be:
               </td>
               <td>${formatCurrency(interestFreeRepaymentsAmount ?? "0")}</td>
            </tr>
            <tr>
               <td>(ii) For the remainder of your Loan Contract, your Repayment Amount will be:</td>
               <td>${formatCurrency(interestBearingRepaymentsAmount)}</td>
            </tr>
            ` : `
            <tr>
               <td>Repayment Amount</td>
               <td>${formatCurrency(interestBearingRepaymentsAmount)}</td>
            </tr>
            `}
            <tr>
               <td>Number of repayments</td>
               <td>${numberOfRepayments}</td>
            </tr>
            <tr>
               <td>Frequency of repayments</td>
               <td class="capitalize">${paymentFrequency}</td>
            </tr>
            <tr>
               <td>First repayment is to be made</td>
               <td>As notified after your purchase is complete. This will reflect your nominated repayment date.</td>
            </tr>
            <tr>
               <td>Total amount of repayments</td>
               <td>${formatCurrency(totalCustomerCost)}</td>
            </tr>
            <tr>
               <td colspan="2">
                  <strong>Credit fees and charges payable on or before we fund your loan</strong>
               </td>
            </tr>
            <tr>
               <td>Origination fee payable before we fund your loan</td>
               <td>${formatCurrency(originationFee)}</td>
            </tr>
            <tr>
               <td colspan="2">
                  <strong>Credit fees and charges that are payable after the date we fund your loan</strong>
               </td>
            </tr>
            <tr>
               <td>Loan Management Fee payable on each repayment date</td>
               <td>${formatCurrency(accountKeepingFee)} ${isMonthlyPaymentFrequency ? "per month" : "per fortnight"}
               </td>
            </tr>
            <tr>
               <td colspan="2">
                  <strong>Credit fees and charges that may be payable after the date we fund your loan</strong>
               </td>
            </tr>
            <tr>
               <td>Late Payment Fee payable when a scheduled payment is missed</td>
               <td>
                  If you do not have any outstanding payments: <br />
                  $5 payable if payment is 1 day late<br />
                  $7.95 payable if payment is 7 days late.<br /><br />
                  If you do have other outstanding payments: <br />
                  $12.95 if a payment is 1 day late.
               </td>
            </tr>
            <tr>
               <td>
                  <strong>Total amount of credit fees and charges payable over the term of your loan assuming the loan runs for the entire loan term (excluding unascertainable amounts and default fees)</strong>
               </td>
               <td>${formatCurrency(totalAccountFees)}</td>
            </tr>
         </table>
         <p>
            Acting reasonably, we may change any of the financial information described above without your consent, including the fees and charges, the amount of repayments,  and the dates for making repayments, and interest rates. We may introduce new fees and charges without your consent. We will inform you of any changes either in writing or by advertisement in a newspaper circulating throughout your jurisdiction. In making any changes, we will act reasonably. 
         </p>
         <!-- end of Financial table -->
         <p>This Financial Table applies to your Request for an Advance for:</p>
         <table>
            <tbody>
               <tr>
                  <td>Amount of Credit</td>
                  <td>${formatCurrency(loanAmount)}</td>
               </tr>
               <tr>
                  <td>Participating Merchant</td>
                  <td>${merchantStoreName}</td>
               </tr>
               <tr>
                  <td>Number of ${isMonthlyPaymentFrequency ? "monthly" : "fortnightly"} repayments</td>
                  <td>${numberOfRepayments}</td>
               </tr>
            </tbody>
         </table>
         <p class="s19">Payment Of Loan</p>
         <table>
            <tbody>
               <tr>
                  <td colspan="2"><strong>Once we approve your Request, we will disburse your loan as follows</strong></td>
               </tr>
               <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
               </tr>
               <tr>
                  <td>We will pay the funds to Payright Merchant ${merchantStoreName} directly to complete your purchase from them.</td>
                  <td>${formatCurrency(loanAmount)}</td>
               </tr>
               <tr>
                  <td>TOTAL</td>
                  <td>${formatCurrency(loanAmount)}</td>
               </tr>
            </tbody>
         </table>
         <p><strong>OTHER PROVISIONS</strong></p>
         <table>
            <tbody>
               <tr>
                  <td>
                     <strong>Loan purpose:</strong> ${loanPurpose} with your Payright Merchant, ${merchantStoreName}
                  </td>
               </tr>
            </tbody>
         </table>
         <p class="font-small" style="page-break-before: always;">Please read the terms of this loan contract carefully.</p>
         <p class="font-small">
            If you have any problems, you should always contact us directly at
            <strong>
            <u>care@payright.com.au</u>
            </strong>
            or phone
            <strong>
            1300 338 496
            </strong>
            . We will endeavour to resolve your query , but if you still have concerns , you should contact our Internal Dispute Resolution ( <strong>IDR</strong>) team to make a formal complaint to
            <strong>
            <u>complaints@payright.com.au</u>
            </strong>
            <strong>or</strong>
            <strong>phone 1300 338 496.</strong> There are no fees or charges for contacting our IDR team.
         </p>
         <p class="font-small">
            <strong>
            IF YOU CANNOT MAKE A PAYMENT, CONTACT US IMMEDIATELY TO DISCUSS YOUR SITUATION BY PHONE ON 1300 338 496 OR EMAIL
            </strong>
            <a href="mailto:care@payright.com.au">
            <strong>CARE@PAYRIGHT.COM.AU</strong>
            </a>
            .
         </p>
         <p class="font-small italic">
            Signed by Navalo Financial Services Group Pty Ltd ACN 605 753 535 and Australian Credit License 533485 as agent for Devizo Finance Pty Ltd by its General Council (Saara Redward) and its CEO (Stewart Creighton).
         </p>
         <div style="display: flex; justify-content: space-between;">
            <svg width="203" height="54" viewBox="0 0 203 54" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
               <rect width="203" height="54" fill="url(#pattern0)"/>
               <defs>
                  <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                     <use xlink:href="#image0_2779_2444" transform="scale(0.00492611 0.0185185)"/>
                  </pattern>
                  <image id="image0_2779_2444" width="203" height="54" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAA2CAYAAABp9230AAAAx3pUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHjabVBBDsMgDLvzij2BxIEmz6FrJ+0He/4CpFNbzRLGxMiEpP3zfqVHB5MkKYtWqzU7xMS4udA80QZTlsEDzzU8utYTahjsJfiOedSo01GnX8DcmqtyCtJnGOvVMIl8vQXFQ+gdsYstgiyCwNOgCGjzW7maLucvrHu+QudKnWwbVzNZdHM7y+LT24q/A+YdhOyMORQw+pKE5oIGK3fFrgFzLtDoxAfyb04H0he4b1n+eNVe2QAAAYRpQ0NQSUNDIHByb2ZpbGUAAHicfZE7SMNQFIb/popVKg52EHHI0DrZRUUcaxWKUCHUCq06mNz0BU0akhQXR8G14OBjserg4qyrg6sgCD5AnB2cFF2kxHOTQosYDxzux3/Pfzj3XEBoVplm9SQATbfNTCop5vKrYt8rAghRxtAvM8uYk6Q0fOPrniop7uK8l3/dnzGoFiwGBETiBDNMm3iDeGbTNjjvE0dYWVaJz4knTBqQ+JHrisdvnEsuC7xnxMxm5okjxGKpi5UuZmVTI54mjqqaTv2FnMcq5y3OWrXO2nPyF4YL+soy1ynHkMIiliBBhII6KqjCRpxOnRQLGbpP+vhHXb9ELoVcFTByLKAGDbLrB/+D37u1ilOTXqdwEuh9cZyPGNC3C7QajvN97DitEyD4DFzpHX+tCcx+kt7oaNEjYGgbuLjuaMoecLkDjDwZsim7UpBSKBaB9zP6pjwwfAsMrHl7a9/j9AHI0q7SN8DBITBeot7rPu8Ode/t35r2/n4AKYlyiRH8ppMAAA16aVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pgo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA0LjQuMC1FeGl2MiI+CiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiCiAgICB4bWxuczpHSU1QPSJodHRwOi8vd3d3LmdpbXAub3JnL3htcC8iCiAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIKICAgeG1wTU06RG9jdW1lbnRJRD0iZ2ltcDpkb2NpZDpnaW1wOjY4YjY4ZTE3LTQ4MzctNGU4Ny05OGM2LTc0ZjI2MGQ0NGZjMiIKICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxOGQ1ZTM2Ny02NDJkLTQyYzMtYWUzZi1lNWRhZmZhY2JiYzciCiAgIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2ZmNkY2Q2MS1hMzI2LTQzOTYtYTEyYi03NzhlMmRiYTQ0YTIiCiAgIEdJTVA6QVBJPSIyLjAiCiAgIEdJTVA6UGxhdGZvcm09Ik1hYyBPUyIKICAgR0lNUDpUaW1lU3RhbXA9IjE3MDQ2NzgwMDUxNDIzOTMiCiAgIEdJTVA6VmVyc2lvbj0iMi4xMC4zNiIKICAgZGM6Rm9ybWF0PSJpbWFnZS9wbmciCiAgIHRpZmY6T3JpZW50YXRpb249IjEiCiAgIHhtcDpDcmVhdG9yVG9vbD0iR0lNUCAyLjEwIgogICB4bXA6TWV0YWRhdGFEYXRlPSIyMDI0OjAxOjA4VDEyOjM5OjU4KzExOjAwIgogICB4bXA6TW9kaWZ5RGF0ZT0iMjAyNDowMTowOFQxMjozOTo1OCsxMTowMCI+CiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InNhdmVkIgogICAgICBzdEV2dDpjaGFuZ2VkPSIvIgogICAgICBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjVmMmRmMTU5LWY5MmEtNDljMi05ODhhLWJlZDllZDYxZjNhZiIKICAgICAgc3RFdnQ6c29mdHdhcmVBZ2VudD0iR2ltcCAyLjEwIChNYWMgT1MpIgogICAgICBzdEV2dDp3aGVuPSIyMDI0LTAxLTA4VDEyOjQwOjA1KzExOjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI/Pjv5ihEAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAHdElNRQfoAQgBKAXi4gICAAAGtElEQVR42u1dPXbaTBS9Puer1ZFqyAJGXoBIA6m0ArEBXIWKbECHBXCo7C4b0GzAVMKNYAGSFiBTRZ26VJPi85szyAJsh2N+9G4DAgzWaO7c9zsCGAwGg8FgMBgMBoPBYDAYDAaDwdjCTRtOMk1TrZQ6+ve6rovhcHgDAHEc6+/fv9/wlGKynAWSJNGbzQYAkGUZ8jzfej/LMlRVBfqMEAK9Xu9T/8fVamV+nyCEwGazQRAErz7f9BoRkMFk2UmC5+dnrNdrAMDz8zOqqkKe568mVBMJPM/D169fz3qSFUWh6ZzeQjJSw/r528dCCHz79o3Jda1kIbNIKbU1caSUZiIEQYDb21ueBC+I41gvl0tznOc56qalPX51M5FxAWSpq4ZSyiiD53nodrsXoQqXgCiKNKmyrdDr9dqMNY29lJIXo3MgS105+v0+vnz5AiklptMpX6ATIQxD3aRKtiLx9fkEskRRZAhiK0ev12Ob+gLUiHwkUiLbHGblP9JAe56nhRA6CAIdRZFO01TzyFzP9Z3NZjoIAg1Ae57X6uv8odUijmM9Ho+R5zmiKDroRJL8N2EwGMDOT0RRpIfD4U2aprosSzw8PGBXjiQMQw4EnDgwE4Zha0y3d51kkiR6OByi1+sZmV6tVgBgwp7kl4RhqPM8NzmGOuyozSGykalAJKIL9S+RnslkoufzOZPsH5VntVphsVjAcRz4vo/RaMQmW7/f1wDq8qsBaCmlDsPw4qQ5jmM2GY+oOi8WhLb9oFYpS5qm+u7uDt1uF7PZ7NWqkSSJXq1W6Ha7oFXGdd3GzPS5hiuLotDswB4HSZLo+XyOLMvw+Ph4VSpzc4got7e3H7JLbT9luVzi6emp0RSTUhrfpdPpsP9xPdBv8Wevhiye5+mX5NZRQ8z11+qlHlTj1VTS0u12t45ZEVhZzsUM02mannS1t4sn7cw0oal+yn7OmerPuT52xHIymVxlbu0gWXBhlckU3lwulyjLcqv2LAzDrc9ytvrfxlgpBdd1W1OZsfcEhRD68fHx4ldmW53sFZDK/EmJ6mZem4sQkyTRi8Via7EhxaBcWNvG5GAy8cU5v/qBsQMS9WpoW5WuJQna1KwWhqEOggBlWaIsS65YfqcZBkouhmHYStufAhIUhKDHJh/pVJOL+mQcxzE+Xd1XS5JEO46DPM/heR7W6zWT4dhkoYG+u7uD7/uYTCYcgXqx20l9yLSziXSM9oMoirSU0nR/CiGglMJoNEKe58aMtMvvN5sNk+CUZLFVRimF+/t7cL/5YTUmEkkpzZjVm7hc18X9/T3KsjSPWZZxEOLSyWI7fovFAj9//mx9rsNWGFrZiSR2vsjeM2A2m3HTWxvIYk8SpRSm0ymCIMCPHz+uUm2iKNL2Sk/h0t+/f2MwGBh16HQ6B88/TVM9Ho/x9PSEOI5ZnS8M/330D8l5LIpCK6Xw8PAAIYQejUbwff+sk1JpmhqH+NevX8bPEEKYCtqqquD7PjabzatedlKIphKefXAcB+PxGH/+/EFZljz72qIs+9SGQq+f3W8Sx7GmSZhlGYIgMCbRdDqFlNIk0U7hD0gp9Vt7gBhXTpYmW14phSzL4DiOsdO73e6bJgt9hxACjuMY0lELsxACALbqyiaTiTn2PA9VVZ0k5G37dr1eD/P5/CZJEs0t1kyWdxFoOBzaqy1c1zXHq9UKvV4PSimEYWhIduoar6IotF2XRmS1N/3zfR9CiK0edlYQJstO1FuIp9Np02fM88FggLfsh9XpdIxD3QRysskMo+fkeFPGmkxF13W3QrQ28jyHlNI480opSCm3Wmnt/58d9RaTZVen276q3wb7fEsVmkru94FWbSEE5vM5giAwu1SSA15VlTHDyFRr2u1xMplgPp8f/K16tXJVVRBCcHiX0UgWQ5J+v//uaM+5o75j4z5wMxrjoLIkSaIBnE3otygKDWBrda/7D28BJQiB/0O4tp9k+0tNm2vsQl1V9xFx13u0VzE7/+zgtxZU19VkFhJ5d71XN3f3bQxug4MJTBYGXm8MbqvbLtLtMj15w3AmC+OAmVpXs0MKVn+t7bVsTBbGFpruktYU/ie0qVWbycL4kD+2T7GIbPWbTpFKXeomIkwWxqf6Wk0qVferzrV1m8nCOKnJ16RI9rG9iYhdGnUKdWKyMC7K7LNzYfTcJpS9U8+xgxFMFsZVmXtNtYXH2pmHycJohZlnByGosp0UiFu8GYwDShSGoblNhpRSA9BBEOhdN99iJjEYNf+IkrUvj8wRBoPBYDAYDAaDcRH4C5qPw9yKOwXqAAAAAElFTkSuQmCC"/>
               </defs>
            </svg>
            <svg width="150" height="64" viewBox="0 0 150 64" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
               <rect width="150" height="64" fill="url(#pattern1)"/>
               <defs>
                  <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
                     <use xlink:href="#image0_2790_2443" transform="scale(0.00666667 0.015625)"/>
                  </pattern>
                  <image id="image0_2790_2443" width="150" height="64" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAABACAYAAAD4Zo7QAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw1AUhU9TpSKVDnYQcchQneyiIoJLrUIRKoRaoVUHk5f+QZOGJMXFUXAtOPizWHVwcdbVwVUQBH9AnB2cFF2kxPuSQosYLzzex3n3HN67DxCaVaZZPQlA020zk0qKufyqGHpFABEAs4jLzDLmJCkN3/q6p26quzjP8u/7swbUgsWAgEicYIZpE28QT2/aBud94igryyrxOfG4SRckfuS64vEb55LLAs+MmtnMPHGUWCx1sdLFrGxqxFPEMVXTKV/Ieaxy3uKsVeusfU/+wnBBX1nmOq0RpLCIJUgQoaCOCqqwEaddJ8VChs6TPv5h1y+RSyFXBYwcC6hBg+z6wf/g92yt4uSElxROAr0vjvMxCoR2gVbDcb6PHad1AgSfgSu94681gZlP0hsdLXYERLaBi+uOpuwBlzvA0JMhm7IrBWkJxSLwfkbflAcGb4H+NW9u7XOcPgBZmlX6Bjg4BMZKlL3u8+6+7rn929Oe3w/JG3LJotWJdAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB+gBDwEBCqvMuMEAACAASURBVHgBAB+B4H4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADHyM3/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC5tr3/Wlhh/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3N7j/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAz8/SAPfz9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvcDL/3V0fADW2d7/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANbV1QD39PQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM7MzADq3NUA1M3LAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOvs76rz8usA8vLoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADY1NEADgsLANjU1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADv7e5VAgEAAC0uMADn5Of/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWLCcCQAAIABJREFUAAAAAAAAAAAAAAAAAAAAAADb4OP/7+vqAElKSwDv7u8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA29naACUkJAAdHyEA6errAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3+LgABQTDgA1PTsA8vb2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN/e3wAuLi8A+vr8AOfp6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM3G0AAjIyEAChMTAAgLDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADm5eMAFxcXAPz7/ADy7/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANvf5f+fmaz/w73O/wAAAAAAAAAAAAAAAOvq78za0dIAQUFBAAcLDQAAAQQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7u7tABkbGgACAgAA4uDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3s6wAtKaZAKKdmACsrrv/8O30ZgAAAADq7OYzBAH2ADY+PgH8+vsA+/j6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPf49wARFBMAGxoYAN7b3wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAampeI6SvlwCSl4IAVFJFARATDJoAAAAAzc7UAB4iIgAAAAAACAMCAPv4+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN7d4f8BAQMAGRsaAR8hHADo5eUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEEd4JEiQBCQ8YAQAAAAAAAAAAAAAAAMfEygAtMjEAAAAAAPHv8QALCgoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADv7e8AGRUZAAAAAAArKikA7+3sAN/e4/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADv8/0i2NbX3ffw7wD5//gA/QIGAAL+AwAG/AQACxoTAAsaEgATDgoAGwoJAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOHg5P9zcHQAMjM1AAAAAADV1NQACQgHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3drcABUSEwAAAAAAHyYnAU0/Sf/h3eEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3uvt/9TU1ADOzNMAXFhaABUHAQAF/P0AEw4NAAsNCgDm7e8A/foCAO/98wAhLyUA0szTANHK0f8vNi8BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADo7vP/9/r6AA0OC4kUCgh4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQ0tQAFRIOAB4fHQEAAAAA2NjXAAYGAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODe3wAsKSkAAAAAAAAAAAAfIxkA4eLcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOnw9O69wMURxL+8AHNjXwA0Li0APzk9AFlFNAAhIhgABg4gAQAAAAAAAAAAAAAAAAAAAADu6d3/Af/zAPHx+gAgJy8BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOru9MyfnqoziXyOAPbv6QAJFA93n6uzd05GQ2cTDwqaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADs7vWIamRqAF1ZTwCXnpoAAAAAAO3s6gAiHx4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADd390AWFhVAAAAAAAAAAAAJygqAM/OzQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7/7/IhECAd4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANHW4P91bHEAEwkEAD0zLQA4YlcAIS80AQAAhwAAAAAAAAAAAAAAAADr7PCqFRQQVgAAAAAAAAAAEhcjAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOnt8u5/fIUREgYAAHdxYwAOEQ7N7e3uM56eogCi5vCZAAAAmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5vD1/5+cqgBLSD4AMCwjAQAAAAAAAAAAuLO3dwkC+QBDRkBFAAAAAAAAAADt7esAOjczAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADq6uzMdXF0AB4mIAEAAAAAAAAAACEiIgC4vMAA7vH1RBIPC7wAAAAAAAAAAAAAAADc6vP/4+XoAOXc3wD+9fEA+ffxAKSTlACgnqEAJykpABYZGAAjIB4BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANfU3P96dHUASUY+AFNUVQATHBgBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFRQQVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACppqsR6+fXAIeblAAQFBwBAAAAAAAAAADf2tf/b3B4ANHR1f8vLysBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADh6e7/l5GcAGdWZAD6/vcACwn8AAAAAAAAAAAAxszS/4V6dwCEfngACg8SvAAAAADt7OyIXFNYACEhIwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7+zoMx8gIAAAAAAAAAAAAOn3+qrUwMcA5+XnAJ+bqruAgJIA6OHdAO7a3QAGBO0Ah29jABURGgAkHyAAJTAmABEOGgAkIiMAChcYAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD69vAA/O7mANzb4gCgrLoAlKam/x4jJAD//QsA4NvbAPPs7wD38PQABP8BAAUJBgABCQQA/QP9ABgXDAAgFR8ADhITABwjHwAcDggBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADl6+//bGJpAH9+dQAQFBwBAAAAAAAAAAAAAAAAISYpAb2wrf8jHRpFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxsjT/+bq9wBBQS9nEw0HmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK+xu/9RT0UBAAAAAAAAAAAAAAAAAAAAAAAAAADq6u7MiYeIABQJCQAhEgMA9v8QAL63wgDn6ev/GRcVAZyUoABBPj0AMTw/AQAAAAAAAAAA8/P5d/Pt8wAaHB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANja5wDt7fkAiYWZ/+Lg2ABwWl4A9+fsAPvv6QDAtaoAZGRbAB5BKAATEhsAEBILAA4bIAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALzY0AfXt5v/X1NoA297mAPHx5ADl0ukABggVAA3+/gASDQUAExcgAPr3+QD8Af0A9P32AO/69QDz2toAuLW3AOTo8QD3Av4AYF1l/zM2OwBDSUMAKiQdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzMnLAB4fFgAwNTsBAAAAAAAAAAAAAAAAAAAAAAAAAABDUFMBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALGytQDm4PEAwbq8mQAAAJoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM7R2P+inJkA8u/yIg4RDt4AAAAAAAAAAAAAAAAAAAAA4eLgMywqJABRUFAAko6UAK+ssgAPEREA8vr6AKKnrP+6p68AZmd+q3R8egAAAAAAAAAAAOXp5wAKCQYAEBIOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMfQ2v96bHMA/fLnAA43NwBFOiwANjlbAA8RHe+Ni4oR6+3yAE9bXAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALExoBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD++e8i8fDl3dvY4ADNxtQAkX1+AHN0gv9KTkgAMTgyRRIGBLwAAAAAAAAAAACrBfA1AAAgAElEQVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANbQ0QAlJyMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANvi6P+BeHgAFw8FAPfx5wDw7e9mEBMRmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4srwAHxkXAA4RDt4AAAAAAAAAAAAAAAAAAAAAAAAAAM/T1wBDQ0kAvsjOALO5vAAZFBEAFBcPAPPq8QCvoqMAeXRmAA4VEFYAAAAAAAAAAAAAAADo5egAFBgTAAkLBiMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD7+fIALSkXAIOBigAPGikBAJsAAAAAAAAAAAAAw7vB/3h6hADd3+b/IyEaAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgcR3gAAAAEAAAAAAAAAAPbw66rT0dRVo5yWALSqHLvU2eIALCceAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADy8O4AKiw3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALK2w/+CeYQA3M/NAFB0YgBIUVcADBIRmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADS1uD/cGFkAGVlYAAAAAAAAAAAAAAAAAAAAAAAAAAAAM/R1v+3s7sA5uDnAK2jpAAwJSAACgcLAB8qLQCjl6AAPDQxADZDSwEAAAAAAAAAAAAAAAAAAAAA49rlAA4TDwALDRHeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8vT4ADE6OQAPGikBAAAAAAAAAAAAAAAAAAAAADQzLUUNCAG7wsPBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKEBVWNz9BAZSioAE3LiEAfG5zANPT2v8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhQTAPHv+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI6Llv+KiJX/yNHb/+32+2bX2ub/ioSY/1JDT/++rJsARTYiAENBQgBUY3EBDBIaAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADl6e7/mpOSAC0qHgAEBwQAAAAAAAAAAAAAAAAAAAAAAAAAAADLzc8AAQH7ALCxqgBiX14AIiYrAOb09gDa4+QA7ezdAGNqYwAAAAAAAAAAAAAAAAAAAAAAAAAAAAH+9gALCwQAAAAAAOvy+qq6wdj/jZms/+vx+KoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6u7yzM7IyAA7OzwAAAAAAAAAAAAAAAAAAAAAAAAAAAAJEhK8SkpAALyysQDv7PWIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOvz+arY4+3/6u/5zAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO/0+SLR3ub/L0lJABUhFQDDwMEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADY3NgDFxcwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKyvt//OztEADAoIAH13egBpXnWZal1tAAP96gCNlHkAkJ6iAUlVVQDyAP4A7/H0IgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADm7fD/oqOnAD44LgBBQkIA6+vxAAAAAAAAAAAAAAAAAAAAAAAAAAAA2NbaAM/N0gBBQ0AAPUJAAPH3+ADl4OEA68/LAHx6dwAQGR0BAAAAAAAAAAAAAAAAAAAAAAAAAAAJDAUA9/IBAAAAAAC8vMJVCgDqAPHf0QCqn6dVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMfByjMaDwwAJiYnAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFdZWwDx7OsAt7u/dwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMrP1/92anYAGBcXAEhWUDPc7fH/EgcFRRIMCrwAAAAA7/L3IvwB/4j2+ftV8fD0APj1+QDz8vUAA/4BAAL//wD99fgA+vf3AAH9+AD8//0AAggEABAVFQAIDgoA5+rlAOTl6ACKj5QAxa6vAAkE9wAXGhgAQWBiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtMCmr7I+TVbrAyP9GQDgBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXDgMAzsS8AAP68wD85dsA4vnaAAYNCwBbZZIAGBobAQAAAAAVGh0BeHF1/8/Q1t0AAAABAAAAAAAAAAAAAAAAAAAAAAAAAADEx9X/fXR3AD04JQBRVlar0dDeVamtjQDj5+z/HRkUAQAAAADv9voiwrvH3YV9dgAbIyMAGSQuAKGqtgC5sLQA9+vnAHmPigAoNjYBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBcSAOnw9QCbp7P/yL23AFGIeYkQEQl3fHeKAOPn7f8dGRMBAAAAAAAAAAAAAAAAAAAAAO3v8WaVlJYAYF5WAABsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXIB8BrZ+Z/5qglQDj8vb/HQ4KAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADs6unu1s3FEd3R0ADc4OUA8/z/APn/+QD/+wUA9PD4AP4A/wAECwUAAggEAA8JEAAA+AAA/Pz7AA8NCwAGAwEABgL8ABALCQAB/PkA/P78AAwSEgAKDxEA+QD9AAAF+wAICwMAFBEcAAn//AAiJiAAFiEnRQMDErwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMm9uP+Xm6YAV2pwAEk+MgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANXW3v/FxL8Ava6tAOLb4AAvNTUAmKihAQAAAAAAAAAAAAAAANPI0P+Zmp4ATVtXACUtKgACBwcA9e/vANzZ2wC/s7QABf35AFpeVgAxOT0BAAAAAAAAAAB/b2z/3N7qAC81PAD9/wAA1dLOABANAwBPTUUAwbu4AOPs8wATFh0A0sXHAO/s5QC8zskAERcbAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANrSzf9uYGEADBgXAIWIjwAnLiwBAAAAAI1/f/8IFB0Aa21kAQAAAAAAAAAAAAAAAAAAAAC1s7r/8evnAFpiXwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPTv6P9ranAAISU0AICCdAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD69OH/8ObY/+vg1v/t5dr/+PHj//z46e4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzsO+/05DTv+CjJf/zNzg/wAAAAAAAAAAAAAAAAAAAADDws3/npWl/2libP9XUVP/jId//9LKu/9cRD7/p5WT/wAAAAAAAAAAAAAAAAAAAAAAAAAA08rC/3tzdP9KTVj/Ulpn/2FWYf+Fe4L/xr68//jx66oAAAAAAAAAAAAAAAAAAAAAAAAAAMizr/+XgYH/o46O/9bDt//07uT/AAAAAAAAAAAAAAAApZ6j/ysbJP9vX2L/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwa6n/9fLv/8AAAAAAAAAAAAAAADf1tP/WE9V/+Xl6/8AAAAAAAAAAAAAAADO1t7/cWly/+3l5/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2NDQ/1M9SP+enav/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADm2tH/rqyzAL3EwAD9+PgAGAoTAPX78wD2AQYABAIJAD44NAA1PTEALzQ0zQkNFjQAAAAA08vI/xcYHAAWHRwBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9vDuRAAB/yIEAv8iBg0UeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1t7g/3xrbQA7NjEA5fHtAI6QlQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGIiv/W2eEAc397ABEaFqvk4uNVi35/AGtkXwA7QkMBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADHs7L/hYSOAFVpagBFUUoAGg8MAQAAAAAAAAAAAAAAAAAAAAAAAAAA6vH2zAb8/Jr++/mZ/wIDzf0JBwACBgW8FAcGeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+9+yI7Oznd/z4/wD9+PcADhUTAA4SEyMBBhHeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGdmbv89LyYAJy0kAJCbnwClo6kBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADz7+5EoJeWu7S4wwAVISMAAfzwAFpWTgBJT1gBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMm8s/+TlZsA7vH8ADAyOAASERgACg0MAPby8gDp6+IA6fbuAPPq9wAZBgAABwHwAPwADQAKCw8ABxEPAAcNFAAJGxkAKCsoACQSEAAmKSEBAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALG0uP+4r64AjI2IRenr67toaW8Ap6mqZxMTDpoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP327Wbh2tWZ5eXlACcsLwAWHyoBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9Ozg/8q+uwDIwMQA8vL7AOrp7wAiISMAEBoSACYvIwAnJioAEBMWAAcICc36+gIA//z3M/n+9wDx7fAA1NvcAOzt8wDgz9wA+wQGACQ3LgA2NjIAMCclAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOfp7v9fWmL/4dfX/wAAAAAAAAAAX1Vc/76/wv8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+9e5E7+bg//jx7IgAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACoo6cANzctAB8pKQEAAAAAAAAAACcjJADV1NUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgsSvAAAAAEAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADd3+P/1tXSAF1fXKsAAAAAAAAAAAAAAAAwMiwA29rbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyMXHAEFCPAANEBVWAAAAAAAAAAAAAAAALjEvANnU2gDj5un/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEfiT7IAACAASURBVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANjW1wA/QD8AAAAAAAAAAAAAAAAAAAAAABwlJQESDxIA3tvfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOHf5f8NDQ0AGx0eAQAAAAAAAAAAAAAAAAAAAAAAAAAAMzMsAMG9vgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADS0tYAKCkoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE1QRADNysgA7uzxiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2t3bACYnJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfIiEjGxgVAMvJzHcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOvu5gAoKSYBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsR3kVGQQCur64AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOnq7O7//f8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7PT4A5ePiAN7g5f8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADv7+0RGRcXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFh0eATMzMAC4tLYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5uPlAA0KCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJSUYAwL67AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPj29QAOCgsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOD09AQH8+wDBwcf/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/v8AEhASAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOTk0Au7q9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBMRAP4AAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQkZEANnQ0gDl4ev/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwdIwDT1t0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkeHgEuLCkAuru7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeIBoB+//yANzh4/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATVNOAL2/uQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARKO+vQAAFlBJREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEdFOACqpaoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA2MwH19vEA2tne/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASEV3uoCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAyPgEWDgwAnp2s/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwLjAAzcrLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZGxnAfHw4wCVnav/7fb4ZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQgOAPjz8wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABralyrEv/uAI2DkpnFzNj/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPb1+QAB//4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADd18//mJGS/5+hsv/a4e7/6/T2qgAAAAAAAAAAAAAAALvJyP9cW17/3dfb/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADW0NP/0tDZAPoEBADv+eoA+ObnAPLm6QD2/vsAV1laADhAQQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7+bk/+PX1QD//wEAIzUzZwwPE5oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAPiY4S+ZDmAAAAABJRU5ErkJggg=="/>
               </defs>
            </svg>
         </div>
         <div style="display: flex; justify-content: space-between;">
            <span>Saara Redward</span>
            <span>Stewart Creighton</span>
         </div>
         <p>&nbsp;</p>
         <p>&nbsp;</p>
         <div class="font-small" style="page-break-before: always;">
            <div>
               <h3 align="center">
                  <strong>Loan Contract - Terms and Conditions</strong>
               </h3>
            </div>
            <div>
               <ol>
                  <!-- Offer of loan-->
                  <li>
                     <p>
                        <strong>Offer of loan</strong>
                     </p>
                     <ol>
                        <li>
                           We offer to make the Amount of Credit available to you on the terms set out in this Loan Contract. This Loan Contract should be read together with:
                           <ol class="lower-alpha">
                              <li>
                                 the  Payright Account Terms and Conditions;
                              </li>
                              <li>
                                 the Application; and
                              </li>
                              <li>
                                 the Financial Table.
                              </li>
                           </ol>
                           <p>
                              (collectively, ‘your Agreement’).
                           </p>
                        </li>
                        <li>
                           Your acceptance of this Loan Contract will constitute your agreement to the terms of this Loan Contract and amounts to your acceptance of the offer we have made to you.
                        </li>
                        <li>
                           <strong>The Loan Date must take place within 90 days of the date you accept this Loan Contract.</strong> If we do not disburse the Amount of Credit within that time (or any extension granted by us, acting reasonably), we may notify you of our decision to: 
                           <p>
                              (a) terminate this Loan Contract; and
                           </p>
                           <p>
                              (b) subject to clause 7.4, keep any fees and charges you have paid to us under your Agreement to the extent they reflect our reasonable costs in assessing your Application. 
                           </p>
                        </li>
                        <li>
                           If any of the following circumstances arise, we will not disburse the Amount of Credit: 
                           <ol class="lower-alpha">
                              <li>
                                 the Participating Merchant notifies us that your purchase has been cancelled; 
                              </li>
                              <li>
                                 you fail to pay any fees specified in the Financial Table to be payable prior to disbursement; 
                              </li>
                              <li>
                                 information has come to our attention or an event has occurred which in our reasonable opinion would have a material impact (as that term is defined in clause 10.1);
                              </li>
                              <li>
                                 we have formed a reasonable suspicion that the application is not bona fide. 
                              </li>
                           </ol>
                        </li>
                     </ol>
                  </li>
                  <!-- Payment of Amount of Credit -->
                  <li>
                     <p>
                        <strong>Payment of Amount of Credit</strong>
                     </p>
                     <ol>
                        <li>
                           After you sign this Loan Contract and the Participating Merchant nominated in your Application in respect of your purchase has confirmed to us that your purchase is complete, we will disburse the Amount of Credit by paying it to the Participating Merchant. 
                        </li>
                     </ol>
                  </li>
                  <!-- Repayments -->
                  <li>
                     <p>
                        <strong>Repayments</strong>
                     </p>
                     <ol>
                        <li>
                           You must repay the Unpaid Balance (and, if applicable, pay interest on the Unpaid Balance) to us in accordance with this Agreement.
                        </li>
                        <li>
                           You must pay all Repayment Amounts to us by the due date as set out in the relevant Financial Table, subject to clause 1.1.
                        </li>
                        <li>
                           Repayments will be credited when they are actually received by us and (subject to clause 3.7) will be applied to your Unpaid Balance as determined by us (acting reasonably). All payments that must be made by you under this Agreement must be made in full, without any deduction, set-off or counterclaim, provided that if you claim that we owe you any amount for any reason, then nothing in this clause will prevent you from bringing a claim for this amount against us. 
                        </li>
                        <li>
                           Repayments are to be made by recurring payment on your debit card or by direct debit from your nominated bank account unless we agree to permit payment by some other method (acting reasonably). You must sign any forms reasonably required by us and do anything reasonably required by us to effect repayments. 
                        </li>
                        <li>
                           You request and authorise us to debit the periodic Repayment Amount or any Fees and Charges from your debit card or your nominated bank account due by you under this loan on each payment due date. The amount of each payment may include any applicable direct debit fees, taxes or charges relating to the payment method. Where you are late in making a payment, we may aggregate amounts and debit this as one amount to your nominated debit card or bank account. 
                        </li>
                        <li>
                           You authorise us to debit the periodic Repayment Amount or any Fees and Charges in accordance with the direct debit authorisation as they become due. You must ensure that the account always has sufficient funds to meet your repayment obligations. If you fail to have sufficient funds in your account, payment may be dishonoured, and a fee may apply. You must not unreasonably cancel the direct debit authority, represent to your bank that the direct debit authority you have given us is unauthorised, or close your account or card without making alternate arrangements and without our prior consent.
                        </li>
                        <li>
                           If any payment you make is insufficient to cover all amounts that are due and payable or is a late payment it will be applied against outstanding interest calculated up to the date when payment is received by us plus any unpaid or
                           overdue interest first (to the maximum extent the payment covers that amount), and then against other fees, and then against principal owing.
                        </li>
                        <li>
                           If your direct debit is dishonoured:
                           <ol class="lower-alpha">
                              <li>
                                 that payment will not be considered as having been made; and
                              </li>
                              <li>
                                 any applicable Fees and Charges specified under the Loan Contract will become due and owing and can be added to the Unpaid Balance or debited to the Loan Account from the date the direct debit was attempted; and
                              </li>
                              <li>
                                 unless an Interest-Free Period applies when the direct debit is dishonoured, any applicable interest will continue to accrue on the Unpaid Balance until actual payment is received by us.  
                              </li>
                           </ol>
                        </li>
                        <li>
                           If a direct debit is unsuccessful, we may make further attempts to debit the amount of the missed Repayment Amount from your account. Where you have multiple unsuccessful payments, we will limit the number of successful loan
                           repayments to no more than three (3) on any one day. Your financial institution may charge you fees if this occurs. If we are processing unpaid Late Fees, there is no limit on how many we will process in any one day.
                        </li>
                        <li>
                           If any repayment is due to be made on a day which is not a business day, the repayment must be made on the next business day. If any payment is due on a day which is the 29th, 30th or 31st of a month with no such date, the payment
                           must be made on the first day of the following month.
                        </li>
                        <li>
                           If any direct debit or recurring payment used for repayment is dishonoured, the repayment will be treated as not having been made, and (unless the repayment is dishonoured during an Interest Free Period), interest will continue to accrue on the Unpaid Balance until actual payment is received by us.
                        </li>
                     </ol>
                  </li>
                  <!-- Early repayment and final repayment adjustments -->
                  <li>
                     <p>
                        <strong>Early repayment and final repayment adjustments</strong>
                     </p>
                     <ol>
                        <li>
                           You can repay the whole or any part of the Unpaid Balance at any time. If you want to pay the Unpaid Balance in whole and terminate this Loan Contract and close your Loan Account, you must tell us the date you want to do this,
                           and we will tell you the amount you owe on the day (including any applicable interest charges to the day).
                        </li>
                        <li>
                           If you repay only part of your Unpaid Balance early, you will still be required to make the minimum repayments required in accordance with the direct debit arrangements regardless of the additional repayments.
                        </li>
                        <li>
                           We will not pay interest on excess funds received by us (i.e., if you repay too much).
                        </li>
                        <li>
                           We may adjust your final repayment amount to the amount required (the
                           <strong>Adjusted Final Repayment Amount</strong>) to repay your Unpaid Balance and accrued fees on the final repayment date, for example if you have made an early repayment, you have made late payments, or to adjust for the number
                           of days in the repayment period or rounding. Your Adjusted Final Repayment Amount may be higher or lower than your scheduled repayment amount, but it will not be more than [$5] higher than your scheduled repayment amount.
                        </li>
                     </ol>
                  </li>
                  <!-- Identification information and credit report -->
                  <li>
                     <p>
                        <strong>Identification information and credit report</strong>
                     </p>
                     <ol>
                        <li>
                           We will collect, store, use and share your personal information (including sensitive information) such as your contact and identification details or geographical information. For more information, go to
                           [https://www.payright.com.au/privacy-policy/].
                        </li>
                        <li>
                           We may ask a credit reporting body to assist in verifying your identity by providing us with an assessment of whether the information we hold about you matches their records. The credit reporting body may use this information and
                           the information held by the body of other individuals for the purpose of preparing and providing this assessment to us.
                        </li>
                        <li>
                           We may further collect, hold, use and disclose your bank statement and credit information such as your credit history, eligibility and credit contract information to request a credit reporting body to pre-screen your credit score
                           in order to proceed with an application for credit and comply with our obligations to report a credit reporting body and/or assist us in assessing any financial application you make and will be done so in accordance with our
                           Privacy Policy.
                        </li>
                        <li>
                           The credit reporting body we may disclose your personal information and credit information to is Equifax. You can get a free copy of your credit report with Equifax by contacting them on 138 332,
                           <a href="http://www.equifax.com.au/personal/products/my-credit-file">
                           www.equifax.com.au/personal/products/my-credit-file
                           </a>
                           or GPO BOX 1969 North Sydney NSW 2060. To obtain Equifax’s policies about their management of credit-related personal information, please visit their website.
                        </li>
                        <li>
                           Our sharing of information about your missed repayments and defaults with the credit reporting body may impact your creditworthiness and your ability to obtain credit in the future. We will only do this if you miss a payment in the Loan Contract, where you have defaulted on the Loan Contract or where you make a serious credit infringement, which is outlined below (Refer to clause 10 (Default)). We may also provide updates to the credit reporting body on any payments we receive after we disclose missed payments and defaults.
                        </li>
                     </ol>
                  </li>
                  <!--Interest charges -->
                  <li>
                     <p>
                        <strong>Interest charges</strong>
                     </p>
                     <ol>
                        <li>
                           If an Interest-Free Period is not specified in the Financial Table, interest accrues daily on the Unpaid Balance, starting on the date the Amount of Credit was disbursed and continues to accrue unless and until the Unpaid Balance
                           is paid in full.
                        </li>
                        <li>
                           If an Interest-Free Period is specified in the Financial Table, interest accrues daily on the Unpaid Balance, starting on the date that the Interest-Free Period ends, and continues to accrue until the Unpaid Balance is paid in
                           full.
                        </li>
                        <li>
                           The interest rate applied each day is equal to the Annual Percentage Rate divided by 365.
                        </li>
                        <li>
                           Interest will be debited periodically in arrears in accordance with your repayment schedule (as shown in the Financial Table) and on the same day as your periodic Repayment Amount. If any day on which interest is due to be debited is not a business day, interest will be debited on the next business day. If any interest is to be debited on a day which is the 29th, 30th or 31st of a month with no such date, the debit will be made on the first day of the following month.  
                        </li>
                        <li>Interest debited to your Loan Account will be added to the Unpaid Balance and will accrue interest at the same rate and in the same manner as the Unpaid Balane.</li>
                        <li>
                           In addition to debiting interest to your Loan Account in accordance with your repayment schedule, we may debit interest if the loan is in default, there is any repayment of the loan, there is any principal increase or variation in your Loan Contract, or any change to the loan term. When debiting interest under this clause, we will not do so before the end of the day to which the interest applies. 
                        </li>
                     </ol>
                  </li>
                  <!-- Fees and charges-->
                  <li>
                     <p>
                        <strong>Fees and charges</strong>
                     </p>
                     <ol>
                        <li>You must pay any fees and charges which become payable under the Loan Contract as listed in the Financial Table to this Loan Contract.</li>
                        <li>
                           If the fee or charge is payable to us, you authorise us to debit your card or your nominated bank account with the amount due on the relevant payment date for that fee or charge. If the payment of a fee or charge is
                           unsuccessful, we will add this amount to the Unpaid Balance, with the exception of any origination fee (if any) that we charge you (as detailed in the Financial Table).
                        </li>
                        <li>
                           You agree to pay the origination fee specified in the Financial Table by debit card prior to the disbursement of the Amount of Credit. 
                        </li>
                        <li>If this Loan Contract is terminated prior to disbursement of the Amount of Credit, we will refund to you the amount of any origination fee that we charged as per clause 7.2.</li>
                        <li>
                           Any fees and charges or other amounts that have accrued and remain outstanding on the final repayment date must be paid along with the final repayment, subject to adjustments if clause 4.4 applies.
                        </li>
                     </ol>
                  </li>
                  <!--Late Fees -->
                  <li>
                     <p>
                        <strong>Late Fees</strong>
                     </p>
                     <ol>
                        <li>
                           If you fail to pay any amount by the due date (including because a direct debit is unsuccessful), we will issue you with a Late Payment Notice and may charge you a Late Payment Fee (if specified in the Late Payment Notice) or part thereof. 
                        </li>
                        <li>
                           We will provide you with notice in accordance with clause 8.1 before any late fees are charged so that you can contact us to make any required repayments.  
                        </li>
                        <li>
                           Where you contact us immediately or make the required repayment within the notice period set out in the Late Payment Notice, no late fees will be charged.
                        </li>
                     </ol>
                  </li>
                  <!-- 9.	Variations to your Loan Contract -->
                  <li>
                     <p>
                        <strong>Variations to your Loan Contract</strong>
                     </p>
                     <ol>
                        <li>
                           There may be times when we need to make changes to your Loan Contract. When we make changes, we will always act fairly and honestly towards you. 
                        </li>
                        <li>
                           If we are required to give you notice of a change, it will be provided in writing. You will receive notice personally. The notice we will provide is set out in the table below. 
                        </li>
                        <li>
                           Where permitted by law, we may give you a notice period that is shorter than set out in the table below, or no notice, of an unfavourable change if we reasonably consider urgent action is necessary to avoid or reduce a material increase in our credit, security, regulatory or reputational risk. 
                        </li>
                        <li>
                           You may choose to terminate this Loan Contract early due to a change made by us under this clause. If you do so, then you must give us reasonable notice and pay the Unpaid Balance. 
                        </li>
                        <li>
                           The changes we may make, and how we will notify you of these changes, is set out in the table below:
                        </li>
                     </ol>
                     <br/>
                     <table style="border: none;vertical-align: top">
                        <tbody>
                           <tr >
                              <td colspan="2" width="397">
                                 <strong>Type of change</strong>
                              </td>
                              <td width="293">
                                 <strong>Notice of change</strong>
                              </td>
                           </tr>
                           <tr>
                              <td rowspan="3" width="113">
                                 <strong>Interest charges</strong>
                              </td>
                              <td width="284">
                                 Changing the Annual Percentage Rate
                              </td>
                              <td width="293">
                                 1 day
                              </td>
                           </tr>
                           <tr>
                              <td width="284">
                                 Changing the method of calculating interest, or frequency of crediting or debiting interest
                              </td>
                              <td width="293">
                                 30 days
                              </td>
                           </tr>
                           <tr>
                              <td width="284">
                                 Changing the existing, or introducing a new, Default Rate
                              </td>
                              <td width="293">
                                 30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement
                              </td>
                           </tr>
                           <tr>
                              <td rowspan="2" width="113">
                                 <strong>Repayments</strong>
                              </td>
                              <td width="284">
                                 Changing the amount of a repayment
                              </td>
                              <td width="293">
                                 30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement
                              </td>
                           </tr>
                           <tr>
                              <td width="284">
                                 Changing the method of calculating repayments, or the number or frequency of repayments, or the time for making repayments
                              </td>
                              <td width="293">
                                 30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement
                              </td>
                           </tr>
                           <tr>
                              <td rowspan="3" width="113">
                                 <p><strong>Fees and Charges </strong></p>
                              </td>
                              <td>
                                 Changing the amount of any Fees and Charges
                              </td>
                              <td>
                                 <p>30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</p>
                              </td>
                           </tr>
                           <tr>
                              <td>
                                 Adding any new Fees and Charges
                              </td>
                              <td>
                                 30 days
                              </td>
                           </tr>
                           <tr>
                              <td>
                                 Changing the method of calculating, or the time or frequency of payment, of any Fees and Charges
                              </td>
                              <td>
                                 30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement
                              </td>
                           </tr>
                           <tr>
                              <td rowspan="2" >
                                 <strong>Government fees and charges</strong>
                              </td>
                              <td>
                                 Adding a new fee or charge set by the government
                              </td>
                              <td >
                                 No later than the day on which the change takes effect, unless:
                                 <ul>
                                    <li>we reasonably consider that the change is not adverse to you, in which case we will notify you in writing before, or with, your next statement; or</li>
                                    <li>
                                       it is publicised by the government, in which case we do not need to notify you.
                                    </li>
                                 </ul>
                              </td>
                           </tr>
                           <tr>
                              <td>
                                 Changing an existing fee or charge set by the government
                              </td>
                              <td width="293">
                                 No later than the day on which the change takes effect, unless:
                                 <ul>
                                    <li>we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement; or</li>
                                    <li>
                                       it is publicised by the government, in which case we do not need to notify you.
                                    </li>
                                 </ul>
                              </td>
                           </tr>
                           <tr>
                              <td width="113">
                                 <strong>Other changes</strong>
                              </td>
                              <td width="284">
                                 In addition to our ability to make the changes outlined above, we can change any term of your Loan Contract:
                                 <ul>
                                    <li>if we reasonably consider that the change is not adverse to you</li>
                                    <li>
                                       to comply with any law, standard, regulator guidance, decision of a court or AFCA
                                    </li>
                                    <li>if we consider it reasonably necessary to manage our regulatory, credit or security ris</li>
                                    <li>if we consider it reasonably necessary to reflect current industry or market products or</li>
                                    <li>if the change is administrative or minor, or to correct a mistake, inconsistency, ambiguity or omission</li>
                                    <li>if the change reflects changes to our business or technological systems</li>
                                    <li> if a product or service has been discontinued, to provide you with a product or service which is substantially similar to the discontinued product or service</li>
                                    <li>to protect us or any other person from the risk of fraud or illegal activity</li>
                                    <li>if the change is otherwise reasonably necessary to protect our legitimate interests</li>
                                 </ul>
                              </td>
                              <td>
                                 30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </li>
                  <!-- Default-->
                  <li>
                     <p>
                        <strong>Default</strong>
                     </p>
                     <ol>
                        <li>
                           If any one or more of the following occur, we may decide that default has occurred.
                           <ol class="lower-alpha">
                              <li>
                                 For any reason, you do not pay any amount when it is due, including Repayment Amounts and Late Fees;
                              </li>
                              <li>
                                 Do any of the following where it has a material impact on us:
                                 <ol class="lower-roman">
                                    <li>
                                       there is a breach by you of any term or condition of this Loan Contract or the Agreement.
                                    </li>
                                    <li>
                                       any representation made by you in relation to your Application for this loan was untrue or misleading.
                                    </li>
                                    <li>
                                       you breach any material undertaking given at any time to us.
                                    </li>
                                    <li>
                                       you do not comply with the law.
                                    </li>
                                    <li>
                                       you have more than one loan with us, and any of your loans with us are in arrears or default.
                                    </li>
                                 </ol>
                              </li>
                              <li>
                                 You become bankrupt or are jailed.
                              </li>
                           </ol>
                           In this clause 10.1, “material impact” means where we reasonably consider that the event, by its nature, is material or the event has had, or is likely to have, a material impact on:
                           <ol class="lower-alpha">
                              <li>
                                 your ability to meet your obligations under this Loan Contract, including but not limited to your obligation to make repayments;
                              </li>
                              <li>
                                 our credit or security risks (or our ability to assess these); or
                              </li>
                              <li>
                                 our legal risks or reputation.
                              </li>
                           </ol>
                        </li>
                        <li>
                           At any time after default occurs, we can take any of the following actions after giving you a Default Notice:
                           <ol class="lower-alpha">
                              <li>
                                 Demand and require payment of any money due under this Loan Contract within 30 days following the expiry of the period outlined in the Default Notice; 
                              </li>
                              <li>
                                 Terminate this Loan Contract;
                              </li>
                              <li>
                                 close, cancel or suspend your Payright Account;
                              </li>
                              <li>
                                 take further action to enforce our rights and recover the amounts due including (but not limited to) referring you to a credit and collection agency.
                              </li>
                           </ol>
                           We can take action even if we do not do so promptly after the default occurs.
                        </li>
                        <li>
                           We will issue you with a Default Notice before we exercise any of our rights under clause 10.2. The Default Notice will advise you of the default and notify you of how to remedy it and by when it must be remedied.  For the avoidance of doubt, we will provide you with at least 30 days notice from the date of the Default Notice to remedy any default.  
                        </li>
                        <li>
                           If we believe that you have fraudulently induced us to enter into the Agreement, and this has a material impact as defined in 10.1 above, or we cannot locate you after making reasonable attempts to do so, or we are otherwise authorised by a court or tribunal, then we are not required to give you a Default Notice and the Unpaid Balance will become due and payable within 3 business days written notice to you. 
                        </li>
                        <li>
                           Unless we agree otherwise, and provided we have not called for immediate payment of all money due under this Loan Contract in accordance with Clause 10.2(a), while you are in default you must still make payments in accordance
                           with the Financial Table until the outstanding balance is paid in full.
                        </li>
                        <li>
                           You indemnify us from and against any reasonable expense, loss, loss of profit, damage or liability which we incur as a result of default incurring, except to the extent caused by our fraud, negligence or wilful misconduct or the fraud, negligence or wilful misconduct of our employees, officers, contractors, agents or receivers.
                        </li>
                     </ol>
                  </li>
                  <!-- Default rate-->
                  <li>
                     <p>
                        <strong>Default rate</strong>
                     </p>
                     <ol>
                        <li>
                           11.1.	If a Repayment Amount is not paid on the due date, you must pay default interest at the applicable Default Rate on the amount in default until it is paid. You may also be liable for default fees. If for any reason, including default, your entire Amount of Credit becomes due, interest at the applicable Default Rate is payable on the entire amount.
                        </li>
                        <li>
                           If you default at any time, we may elect not to charge default interest or fees at that time. However, we reserve the right to charge default interest and fees at a later time, including retrospectively for any period during which you were in default.
                        </li>
                     </ol>
                  </li>
                  <!--Termination  -->
                  <li>
                     <p>
                        <strong>Termination</strong>
                     </p>
                     <ol>
                        <li>Except to the extent provided elsewhere in this Loan Contract, this Loan Contract will continue until terminated by you or us in accordance with this clause 12.</li>
                        <li>Either you or we may terminate this Loan Contract immediately by notice provided that the Unpaid Balance is nil.</li>
                        <li>
                           If the Unpaid Balance is greater than nil, then:
                           <ol class="lower-alpha">
                              <li>
                                 You may terminate this Loan Contract only after paying out the Unpaid Balance in accordance with this Loan Contract; and
                              </li>
                              <li>we may only terminate this Loan Contract in accordance with clauses 1.3(a)and 10.2(b) above.</li>
                           </ol>
                        </li>
                     </ol>
                  </li>
                  <!-- General matters-->
                  <li>
                     <p>
                        <strong>General matters</strong>
                     </p>
                     <ol>
                        <li>
                           You must pay us on request any
                           <ol class="lower-alpha">
                              <li>government duties, taxes and</li>
                              <li>other charges on receipts, duties of withdrawals that apply to your loan. We may debit these duties, taxes and charges to your Loan Account as and when they become payable.</li>
                           </ol>
                        </li>
                        <li>You must promptly produce documents (such as financial statements) or other evidence we require to enable us to verify your identity or other information about you.</li>
                        <li>You must tell us if you change your residential, postal, email address or contact number.</li>
                        <li>
                           There may be some statutes (i.e., laws passed by parliament) or other law (usually called common law) intended to limit our rights. None of those statutes or laws will operate to limit our rights under this Loan Contract unless by
                           law those rights cannot be negated. In particular, we need not give any notice before exercising any right, power or remedy under this Loan Contract unless required by law. If the law does require notice,
                           we need only give one day’s notice, or the shortest notice required by that law.
                        </li>
                        <li>
                           If the law does require us to give you notice before exercising rights, we may not have to give notice if:
                           <ol class="lower-alpha">
                              <li>we cannot locate you after making reasonable attempts to do so; or</li>
                              <li>we are authorised by a court.</li>
                           </ol>
                        </li>
                        <li>
                           If any of the provisions of this Loan Contract are illegal or become illegal at any time, the affected provisions will cease to have effect, but the balance of the Loan Contract will remain in full force and effect.
                        </li>
                        <li>Statements of account will be forwarded to you at least once every six months or more frequently if requested by you or as required by law.</li>
                        <li>
                           13.8.	We may assign, novate or otherwise deal with our rights and obligations under this loan contract and any document or agreement entered into or provided under or in connection with this Loan Contract in any way we wish. We may disclose personal and credit information about you in connection with any such dealing. You must sign anything and do anything we reasonably require to enable any dealing with this Loan Contract and any document or agreement entered into or provided under or in connection with this Loan Contract. You cannot assign or otherwise deal with your rights or obligations under this Loan Contract and any document or agreement entered into or provided under or in connection with this Loan Contract.
                        </li>
                        <li>
                           Any communications, originating process, court document or other document to be given or served under or in connection with this Loan Contract or any security associated with this Loan Contract may be:
                           <ol class="lower-alpha">
                              <li>delivered personally to you;</li>
                              <li>posted to or left at your residential or business address last known to us;</li>
                              <li>posted to or left at the address shown in your Loan Contract;</li>
                              <li>sent by electronic communication (for example, email or SMS); or</li>
                              <li>given in any other way permitted by law.</li>
                           </ol>
                           <p>The notice may be signed by any employee, solicitor, or agent on our behalf.</p>
                        </li>
                        <li>
                           This Loan Contract is governed by and interpreted in accordance with the law for the time being in force in the place shown as your address in this Loan Contract.
                           <p>References to a person include a reference to companies and trusts and any other kind of body. Singular words include plural words and vice versa.</p>
                        </li>
                     </ol>
                  </li>
                  <!--Definitions -->
                  <li>
                     <p>
                        <strong>Definitions</strong>
                     </p>
                     <p>
                        In this Loan Contract, capitalised terms have the meaning given in the Payright Account Terms and Conditions or as otherwise specified below:
                     </p>
                     <p><strong>Amount of Credit</strong> means the dollar amount set out in the Financial Table attached to this Loan Contract, or any Financial Table that replaces it upon variation of this Loan Contract.</p>
                     <p><strong>Annual Percentage Rate</strong> means the rate of interest per annum applying to this Loan Contract, as appearing in the Financial Table.</p>
                     <p><strong>Application</strong> has the meaning given in the Payright Account Terms and Conditions.</p>
                     <p><strong>Default</strong> has the meaning given in clause 10.</p>
                     <p>
                        <strong>Default Notice</strong> means the written notice provided to you by us notifying you that you are in default of this Loan Contract, setting out the particulars of the default and advising you on the means to rectify the
                        default (if available).
                     </p>
                     <p><strong>Default Rate</strong> means the default rate appearing in the Financial Table</p>
                     <p><strong>Fees and Charges</strong> means the fees and charges set out in the Financial Table attached to this Loan Contract (as varied by us in accordance with your Agreement). </p>
                     <p><strong>Financial Table</strong> means the table on page 1 of this Loan Contract.</p>
                     <p><strong>Interest-Free Period</strong> means the period specified in the Financial Table (if any) as being the period during which you will not be charged interest.</p>
                     <p><strong>Late Payment Fee</strong> means any such fee detailed in the Financial Table.</p>
                     <p><strong>Late Payment Notice</strong> means a notice provided to you by Payright if you fail to make a payment under this Loan Contract by the due date for that payment.</p>
                     <p>
                        <strong>Loan Account</strong> means the records relating to the Loan Contract as shown in your Payright Account.
                        <strong></strong>
                     </p>
                     <p><strong>Loan Contract</strong> means this loan contract, including any Financial Table.</p>
                     <p><strong>Loan Date</strong> means the date we first advance the Amount of Credit to you.</p>
                     <p><strong>Payright Account</strong> has the meaning given in the Term and Conditions.</p>
                     <p><strong>Repayment Amount</strong> means the repayment amount shown in the Financial Table.</p>
                     <p><strong>Payright Account Terms and Conditions</strong> means the term and conditions governing your Payright Account.</p>
                     <p><strong>Unpaid Balance</strong> on any given day means the amount you owe us at the close of that day, being the aggregation of all amounts debited and credited to your Loan Account.</p>
                     <p>
                        <strong>You or your</strong> means the borrower/s named in Item 1 of the Schedule. If there is more than one of you, each of you is liable jointly and each of you is liable severally. This will continue, as regards the others, even
                        if one or more of you is no longer liable.
                     </p>
                     <p><strong>We, us or our </strong>means Navalo Financial Services Group Pty Ltd acting as agent of Devizo Finance Pty Ltd.</p>
                  </li>
               </ol>
               <p>
                  The following statement is prescribed by law. Not all of the information in this statement may apply to you.
               </p>
            </div>
            <div align="center">
               <span>
               <strong>INFORMATION STATEMENT</strong>
               </span>
               <br />
               <span>
               <strong>THINGS YOU SHOULD KNOW ABOUT YOUR PROPOSED CREDIT CONTRACT</strong>
               </span>
            </div>
            <p>
               This statement tells you about some of the rights and obligations of yourself and your credit provider. It does not state the terms and conditions of your contract.
            </p>
            <p>
               If you have any concerns about your contract, contact the credit provider and, if you still have concerns, the AFCA scheme, or get legal advice.
            </p>
            <br />
            <table style="border-collapse: collapse; border: none;">
               <tbody>
                  <tr>
                     <td style="background: rgb(191, 191, 191); vertical-align: top;">
                        <p style="margin: 0; font-size: 15px; text-align: center; line-height: 12pt; vertical-align: baseline;">
                           <strong>THE CONTRACT</strong>
                        </p>
                     </td>
                  </tr>
                  <tr>
                     <td>
                        <ol>
                           <li>
                              <strong>
                              How can I get details of my proposed credit contract?
                              </strong>
                              <p>
                                 Your credit provider must give you a precontractual statement containing certain information about your contract. The precontractual statement, and this document, must be given to you before:
                              </p>
                              <ul>
                                 <li>
                                    your contract is entered into; or
                                 </li>
                                 <li>
                                    you make an offer to enter into the contract;
                                    <br />
                                    whichever happens first.
                                 </li>
                              </ul>
                           </li>
                           <li>
                              <strong>How can I get a copy of the final contract?</strong>
                              <p>
                                 If the contract document is to be signed by you and returned to your credit provider, you must be given a copy to keep.
                              </p>
                              <p>
                                 Also, the credit provider must give you a copy of the final contract within 14 days after it is made. This rule does not, however, apply if the credit provider has previously given you a copy of the contract document to keep.
                              </p>
                              <p>
                                 If you want another copy of your contract, write to your credit provider and ask for one. Your credit provider may charge you a fee. Your credit provider has to give you a copy:
                              </p>
                              <ul>
                                 <li>
                                    within 14 days of your written request if the original contract came into existence 1 year or less before your request; or
                                 </li>
                                 <li>
                                    otherwise within 30 days of your written request.
                                 </li>
                              </ul>
                           </li>
                           <li>
                              <strong>Can I terminate the contract?</strong>
                              <p>
                                 Yes. You can terminate the contract by writing to the credit provider so long as:
                              </p>
                              <ul>
                                 <li>
                                    you have not obtained any credit under the contract; or
                                 </li>
                                 <li>
                                    a card or other means of obtaining credit given to you by your credit provider has not been used to acquire goods or services for which credit is to be provided under the contract.
                                 </li>
                              </ul>
                              <p>
                                 However, you will still have to pay any fees or charges incurred before you terminate the contract.
                              </p>
                           </li>
                           <li>
                              <strong>Can I pay my credit contract out early?</strong>
                              <p>
                                 Yes. Pay your credit provider the amount required to pay out your credit contract on the day you wish to end your contract.
                              </p>
                           </li>
                           <li>
                              <strong>How can I find out the pay out figure?</strong>
                              <p>
                                 You can write to your credit provider at any time and ask for a statement of the pay out figure as at any date you specify. You can also ask for details of how the amount is made up.
                              </p>
                              <p>
                                 Your credit provider must give you the statement within 7 days after you give your request to the credit provider. You may be charged a fee for the statement.
                              </p>
                           </li>
                           <li>
                              <strong>Will I pay less interest if I pay out my contract early?</strong>
                              <p>
                                 Yes. The interest you can be charged depends on the actual time money is owing. However, you may have to pay an early termination charge (if your contract permits your credit provider to charge one) and other fees.
                              </p>
                           </li>
                           <li>
                              <strong>Can my contract be changed by my credit provider?</strong>
                              <p>Yes, but only if your contract says so.</p>
                           </li>
                           <li>
                              <strong>
                              Will I be told in advance if my credit provider is going to make a change in the contract?
                              </strong>
                              <p>
                                 That depends on the type of change. For example:
                              </p>
                              <ul>
                                 <li>
                                    you get at least same day notice for a change to an annual percentage rate. That notice may be a written notice to you, or a notice published in a newspaper.
                                 </li>
                                 <li>
                                    you get 20 days advance written notice for:
                                    <ul class="circle">
                                       <li>a change in the way in which interest is calculated; or</li>
                                       <li>a change in credit fees and charges; or</li>
                                       <li>any other changes by your credit provider;</li>
                                    </ul>
                                 </li>
                              </ul>
                              <p>
                                 except where the change reduces what you have to pay, or the change happens automatically under the contract.
                              </p>
                           </li>
                           <li>
                              <strong>
                              Is there anything I can do if I think that my contract is unjust?
                              </strong>
                              <p>
                                 Yes. You should first talk to your credit provider. Discuss the matter and see if you can come to some arrangement.
                              </p>
                              <p>
                                 If that is not successful, you may contact the AFCA scheme. The AFCA scheme is a free service established to provide you with an independent mechanism to resolve specific complaints. The AFCA scheme can be contacted at 1800 931
                                 678, https://www.afca.org.au/ and GPO Box 3, Melbourne, VIC 3001.
                              </p>
                              <p>
                                 Alternatively, you can go to court. You may wish to get legal advice, for example from your community legal centre or Legal Aid.
                              </p>
                              <p>
                                 You can also contact ASIC, the regulator, for information on 1300 300 630 or through ASIC’s website at
                                 <a href="http://www.asic.gov.au">
                                 http://www.asic.gov.au
                                 </a>
                                 .
                              </p>
                           </li>
                        </ol>
                     </td>
                  </tr>
                  <tr>
                     <td style="background: rgb(191, 191, 191); vertical-align: top;">
                        <p style="margin: 0; font-size: 15px; text-align: center; font-size: 15px; text-align: center; line-height: 12pt; vertical-align: baseline;">
                           <strong>General</strong>
                        </p>
                     </td>
                  </tr>
                  <tr>
                     <td>
                        <ol style="counter-reset: item 9;">
                           <li>
                              <strong>What do I do if I can not make a repayment?</strong>
                              <p>
                                 Get in touch with your credit provider immediately. Discuss the matter and see if you can come to some arrangement. You can ask your credit provider to change your contract in a number of ways:
                              </p>
                              <ul>
                                 <li>
                                    to extend the term of your contract and reduce payments; or
                                 </li>
                                 <li>
                                    to extend the term of your contract and delay payments for a set time; or
                                 </li>
                                 <li>
                                    to delay payments for a set time.
                                 </li>
                              </ul>
                           </li>
                           <li>
                              <strong>
                              What if my credit provider and I cannot agree on a suitable arrangement?
                              </strong>
                              <p>
                                 If the credit provider refuses your request to change the repayments, you can ask the credit provider to review this decision if you think it is wrong.
                              </p>
                              <p>
                                 If the credit provider still refuses your request you can complain to the AFCA scheme. Further details about this scheme are set out below.
                              </p>
                           </li>
                           <li>
                              <strong>
                              Can my credit provider take action against me?
                              </strong>
                              <p>
                                 Yes, if you are in default under your contract. But the law says that you can not be unduly harassed or threatened for repayments. If you think you are being unduly harassed or threatened, contact the AFCA scheme or ASIC, or get
                                 legal advice.
                              </p>
                           </li>
                           <li>
                              <strong>
                              Do I have any other rights and obligations?
                              </strong>
                              <p>
                                 Yes. The law will give you other rights and obligations. You should also READ YOUR CONTRACT carefully.
                              </p>
                           </li>
                        </ol>
                     </td>
                  </tr>
               </tbody>
            </table>
            <br>
            <div class="grey-box">
               <p>
                  <strong>
                  IF YOU HAVE ANY COMPLAINTS ABOUT YOUR CREDIT CONTRACT, OR WANT MORE INFORMATION, CONTACT YOUR CREDIT PROVIDER. YOU MUST ATTEMPT TO RESOLVE YOUR COMPLAINT WITH YOUR CREDIT PROVIDER BEFORE CONTACTING THE AFCA SCHEME. IF YOU HAVE A
                  COMPLAINT WHICH REMAINS UNRESOLVED AFTER SPEAKING TO YOUR CREDIT PROVIDER YOU CAN CONTACT THE AFCA SCHEME OR GET LEGAL ADVICE.
                  </strong>
               </p>
               <p>
                  <strong>
                  THE AFCA SCHEME IS A FREE SERVICE ESTABLISHED TO PROVIDE YOU WITH AN INDEPENDENT MECHANISM TO RESOLVE SPECIFIC COMPLAINTS. THE AFCA SCHEME CAN BE CONTACTED AT 1800 931 678, HTTPS://WWW.AFCA.ORG.AU/ AND GPO BOX 3, MELBOURNE, VIC 3001.
                  </strong>
               </p>
               <p>
                  <strong>
                  PLEASE KEEP THIS INFORMATION STATEMENT. YOU MAY WANT SOME INFORMATION FROM IT AT A LATER DATE.
                  </strong>
               </p>
            </div>
         </div>
         <br clear="all" />
         <table style="border: none;" class="font-small">
            <tbody>
               <tr style="text-align: center;">
                  <td colspan="2">
                     <p>
                        <strong>IMPORTANT</strong>
                     </p>
                  </td>
               </tr>
               <tr style="vertical-align: top;">
                  <td style="width: 50%;">
                     <p>
                        <strong>BEFORE YOU SIGN</strong>
                     </p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp; READ THIS CONTRACT DOCUMENT so that you know exactly what contract you are entering into and what you will have to do under the contract.</p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp; You should also read the information statement: &lsquo;THINGS YOU SHOULD KNOW ABOUT YOUR PROPOSED CREDIT CONTRACT&rsquo;.</p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp; Fill in or cross out any blank spaces.</p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp; Get a copy of this contract document.</p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp; <strong>Do not sign</strong> this contract document if there is anything you do not understand.</p>
                  </td>
                  <td>
                     <p>
                        <strong>THINGS YOU MUST KNOW</strong>
                     </p>
                     <p>
                        *&nbsp;&nbsp;&nbsp;&nbsp; Once you sign this contract document, you will be bound by it. However, you may end the contract before you obtain credit, or a card or other means is used to obtain goods or services for which credit is to
                        be provided under the contract, by telling the credit provider in writing, but you will still be liable for any fees or charges already incurred.
                     </p>
                     <p>*&nbsp;&nbsp;&nbsp;&nbsp;If you take out insurance, the credit provider can not insist on any particular insurance company.</p>
                     <p>
                        *&nbsp;&nbsp;&nbsp;&nbsp; If this contract document says so, the credit provider can vary the annual percentage rate (the interest rate), the repayments and the fees and charges and can add new fees and charges without your consent
                     </p>
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
   </body>
</html> `;
};
const formatCurrencyButZeroIsBlank$1 = (amount) => !amount ? "" : formatCurrency(amount);
const formatDate$1 = (date) => date.split("-").reverse().join("/");
const customerStatementTemplate = ({
  startDate,
  endDate,
  closingBalance,
  contract,
  customer,
  lines
}) => `
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet">
    <style>
      body {
        font-family: Verdana, sans-serif;
        font-size: 10px;
      }

      table {
        border-collapse: collapse;
        width: 100%;
        font-size: 10px;
      }

      th,
      td {
        padding: 5px;
        vertical-align: top;
      }

      td {
        border: 1px solid lightgray;
      }

      img {
        width: 100%;
        height: 100%;
      }

      p {
        margin: 0px;
      }

      .align-start {
        text-align: start;
      }

      .align-end {
        text-align: end;
      }

      .nowrap {
        white-space: nowrap;
      }

      .statement {
        display: grid;
        grid-template-columns: auto;
        row-gap: 6rem;
      }

      .statement-intro {
        display: grid;
        grid-template-columns: auto;
        row-gap: 2rem;
      }

      .statement-header {
        display: grid;
        grid-template-columns: 40% auto;
        grid-template-rows: min-content min-content;
        align-items: center;
        justify-content: space-between;
        row-gap: 1rem;
        background-color: #eff1f6;
        padding: 5rem 2rem;
      }

      .statement-header-title {
        color: darkslategray;
        font-size: 42px;
        font-weight: bold;
        line-height: 48px;
      }

      .statement-header-trading-as {
        color: #240050;
      }

      .statement-info-panel {
        display: grid;
        grid-template-columns: auto min-content;
      }

      .statement-summary {
        display: grid;
        grid-template-columns: min-content min-content;
        column-gap: 3rem;
        row-gap: 0.25rem;
        background-color: #eff1f6;
        padding: 1rem;
        color: #240050;
      }

      .statement-body {
        display: grid;
        row-gap: 1rem;
      }

      .statement-table-header {
        background-color: #240050;
        display: table-header-group;
      }

      .statement-table-header th {
        color: white;
        font-weight: normal;
      }

      .statement-table-footer {
        background-color: #240050;
      }

      .statement-table-footer td {
        color: white;
        font-weight: normal;
        text-align: start;
      }

      .statmenet-table-footer-balance {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .statement-fee-info {
        break-inside: avoid;
      }

      .statement-fee-info ul {
        list-style-type: square;
        padding-inline-start: 2rem;
        margin-block-start: 0.25rem;
        margin-block-end: 0px;
      }
    </style>
  </head>
  <body>
    <div class="statement">
      <div class="statement-intro">
        <div class="statement-header">
          <div class="statement-header-logo-container">
            <img src="data:image/png;base64,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" />
          </div>
          <p class="statement-header-title">
            STATEMENT
          </p>
          <p class="statement-header-trading-as">
            Devizo Finance AU Pty Ltd ABN 21 622 104 527<br />
            Trading as Payright
          </p>
        </div>
        <div class="statement-info-panel">
          <p class="customer-details">
            ${customer.salutation} ${customer.firstName} ${customer.lastName}<br />
            ${customer.street}<br />
            ${customer.city} ${customer.state} ${customer.postCode}<br />
            <br />
            <br />
            ${customer.email}
          </p>
          <div class="statement-summary">
            <div class="nowrap">
              Contract Reference
            </div>
            <div class="nowrap">
              ${contract.customerNumber}
            </div>
            <div class="nowrap">
              Statement Period
            </div>
            <div class="nowrap">
              ${formatDate$1(startDate)} - ${formatDate$1(endDate)}
            </div>
            <div class="nowrap">
              Date Contract Accepted
            </div>
            <div class="nowrap">
              ${!contract.acceptedDate ? "" : formatDate$1(contract.acceptedDate)}
            </div>
            <div class="nowrap">
              Approved Credit Limit
            </div>
            <div class="nowrap">
              ${formatCurrency(contract.approvedCreditLimit)}
            </div>
            <div class="nowrap">
              Available Credit
            </div>
            <div class="nowrap">
              ${formatCurrency(contract.availableCredit)}
            </div>
            <div class="nowrap">
              Repayment Frequency
            </div>
            <div class="nowrap">
              ${contract.repaymentFrequency}
            </div>
            <div class="nowrap">
              Next Minimum Repayment Amount
            </div>
            <div class="nowrap">
              ${formatCurrency(contract.nextMinimumRepaymentAmount)}
            </div>
          </div>
        </div>
      </div>
      <div class="statement-body">
        <table>
          <thead class="statement-table-header">
            <th class="align-start">Date</th>
            <th class="align-start">Description</th>
            <th class="align-end">Debit</th>
            <th class="align-end">Credit</th>
            <th class="align-end">Balance</th>
          </thead>
          ${lines.map(
  (line) => `
            <tr>
              <td>
                ${formatDate$1(line.date)}
              </td>
              <td>
                ${line.description}
              </td>
              <td class="align-end">
                ${formatCurrencyButZeroIsBlank$1(line.debit)}
              </td>
              <td class="align-end">
                ${formatCurrencyButZeroIsBlank$1(line.credit)}
              </td>
              <td class="align-end">
                ${formatCurrency(line.balance)}
              </td>
            </tr>
          `
).join(" ")}
          <tr class="statement-table-footer">
            <td colspan="7">
              <div class="statmenet-table-footer-balance">
                <span>Closing Balance</span>
                <span>${formatCurrency(closingBalance)}</span>
              </div>
            </th>
          </tr>
        </table>
      </div>
    </div>
  </body>
</html>
`;
const formatCurrencyButZeroIsBlank = (amount) => !amount ? "" : formatCurrency(amount);
const formatDate = (date) => date.split("-").reverse().join("/");
const loanStatementTemplate = ({
  startDate,
  endDate,
  openingBalance,
  closingBalance,
  merchantStore,
  loan,
  customer,
  fees,
  lines
}) => `
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet">
    <style>
      body {
        font-family: Verdana, sans-serif;
        font-size: 10px;
      }

      table {
        border-collapse: collapse;
        width: 100%;
        font-size: 10px;
      }

      th,
      td {
        padding: 5px;
        vertical-align: top;
      }

      td {
        border: 1px solid lightgray;
      }

      img {
        width: 100%;
        height: 100%;
      }

      p {
        margin: 0px;
      }

      .align-start {
        text-align: start;
      }

      .align-end {
        text-align: end;
      }

      .nowrap {
        white-space: nowrap;
      }

      .statement {
        display: grid;
        grid-template-columns: auto;
        row-gap: 6rem;
      }

      .statement-intro {
        display: grid;
        grid-template-columns: auto;
        row-gap: 2rem;
      }

      .statement-header {
        display: grid;
        grid-template-columns: 40% auto;
        grid-template-rows: min-content min-content;
        align-items: center;
        justify-content: space-between;
        row-gap: 1rem;
        background-color: #eff1f6;
        padding: 5rem 2rem;
      }

      .statement-header-title {
        color: darkslategray;
        font-size: 42px;
        font-weight: bold;
        line-height: 48px;
      }

      .statement-header-trading-as {
        color: #240050;
      }

      .statement-info-panel {
        display: grid;
        grid-template-columns: auto min-content;
      }

      .statement-summary {
        display: grid;
        grid-template-columns: min-content min-content;
        column-gap: 3rem;
        row-gap: 0.25rem;
        background-color: #eff1f6;
        padding: 1rem;
        color: #240050;
      }

      .statement-body {
        display: grid;
        row-gap: 1rem;
      }

      .statement-table-header {
        background-color: #240050;
        display: table-header-group;
      }

      .statement-table-header th {
        color: white;
        font-weight: normal;
      }

      .statement-table-footer {
        background-color: #240050;
      }

      .statement-table-footer td {
        color: white;
        font-weight: normal;
        text-align: start;
      }

      .statmenet-table-footer-balance {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .statement-fee-info {
        break-inside: avoid;
      }

      .statement-fee-info ul {
        list-style-type: square;
        padding-inline-start: 2rem;
        margin-block-start: 0.25rem;
        margin-block-end: 0px;
      }
    </style>
  </head>
  <body>
    <div class="statement">
      <div class="statement-intro">
        <div class="statement-header">
          <div class="statement-header-logo-container">
            <img src="data:image/png;base64,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" />
          </div>
          <p class="statement-header-title">
            STATEMENT
          </p>
          <p class="statement-header-trading-as">
            Devizo Finance AU Pty Ltd ABN 21 622 104 527<br />
            Trading as Payright
          </p>
        </div>
        <div class="statement-info-panel">
          <p class="customer-details">
            ${customer.salutation} ${customer.firstName} ${customer.lastName}<br />
            ${customer.street}<br />
            ${customer.city} ${customer.state} ${customer.postCode}<br />
            <br />
            <br />
            ${customer.email}
          </p>
          <div class="statement-summary">
            <div class="nowrap">
              Loan No.
            </div>
            <div class="nowrap">
              ${loan.name}
            </div>
            <div class="nowrap">
              Merchant Store
            </div>
            <div class="nowrap">
              ${merchantStore.name}
            </div>
            <div class="nowrap">
              Statement period
            </div>
            <div class="nowrap">
              ${formatDate(startDate)} - ${formatDate(endDate)}
            </div>
            <div class="nowrap">
              Loan Origination Date
            </div>
            <div class="nowrap">
              ${formatDate(loan.originationDate)}
            </div>
            <div class="nowrap">
              Opening Balance
            </div>
            <div class="nowrap">
              ${formatCurrency(openingBalance)}
            </div>
            <div class="nowrap">
              Closing Balance
            </div>
            <div class="nowrap">
              ${formatCurrency(closingBalance)}
            </div>
            <div class="nowrap">
              Interest Rate
            </div>
            <div class="nowrap">
              ${loan.interestRate}%
            </div>
            ${!loan.interestFreeMonths ? "" : `
              <div class="nowrap">
                Interest Free period
              </div>
              <div class="nowrap">
                ${loan.interestFreeMonths} Month${loan.interestFreeMonths === 1 ? "" : "s"}
              </div>
            `}
            <div class="nowrap">
              Next Minimum Repayment Amount
            </div>
            <div class="nowrap">
              ${formatCurrency(loan.nextPaymentAmount)}
            </div>
            <div class="nowrap">
              Payment Frequency
            </div>
            <div class="nowrap">
              ${loan.repaymentFrequency}
            </div>
          </div>
        </div>
      </div>
      <div class="statement-body">
        <table>
          <thead class="statement-table-header">
            <th class="align-start">Date</th>
            <th class="align-start">Description</th>
            <th class="align-end">Principal</th>
            <th class="align-end">Accrued Interest</th>
            <th class="align-end">Other Fee*</th>
            <th class="align-end">Total Paid</th>
            <th class="align-end">Balance</th>
          </thead>
          ${lines.map(
  (line) => `
            <tr>
              <td>
                ${formatDate(line.date)}
              </td>
              <td>
                ${line.description}
              </td>
              <td class="align-end">
                ${formatCurrencyButZeroIsBlank(line.principal)}
              </td>
              <td class="align-end">
                ${formatCurrencyButZeroIsBlank(line.accruedInterest)}
              </td>
              <td class="align-end">
                ${formatCurrencyButZeroIsBlank(line.otherFee)}
              </td>
              <td class="align-end">
                ${line.isApplied ? formatCurrencyButZeroIsBlank(line.totalPaid) : ""}
              </td>
              <td class="align-end">
                ${formatCurrency(line.balance)}
              </td>
            </tr>
          `
).join(" ")}
          <tr class="statement-table-footer">
            <td colspan="7">
              <div class="statmenet-table-footer-balance">
                <span>Closing Balance</span>
                <span>${formatCurrency(closingBalance)}</span>
              </div>
            </th>
          </tr>
        </table>
        <div class="statement-fee-info">
          *Other Fee includes the following
          <ul>
          <li>Loan Management Fee - Up to ${formatCurrency(
  fees.managementFeeMonthly
)} per month depending on repayment frequency</li>
          <li>Late Payment Fee - Up to ${formatCurrency(fees.latePaymentFee)}</li>
          </ul>
        </div>
      </div>
    </div>
  </body>
</html>
`;
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
const getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
const ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ZodError extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
const errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
let overrideErrorMap = errorMap;
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      overrideMap,
      overrideMap === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key,
        value
      });
    }
    return ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return state.set(receiver, value), value;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
}
const handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    var _a, _b;
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
class ZodType {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
  if (args.precision) {
    regex = `${regex}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    regex = `${regex}(\\.\\d+)?`;
  }
  return regex;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
class ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a, _b;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
      local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  duration(message) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodString.create = (params) => {
  var _a;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
}
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
class ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
}
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
class ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
class ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
class ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
class ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
class ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
}
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
class ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
class ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue, ctx) => {
          var _a, _b, _c, _d;
          const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
class ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
const getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
class ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
}
function mergeValues(a, b2) {
  const aType = getParsedType(a);
  const bType = getParsedType(b2);
  if (a === b2) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b2);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b2 };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b2[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b2.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b2[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b2) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
class ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
}
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
class ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple({
      ...this._def,
      rest
    });
  }
}
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
}
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
class ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
}
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
class ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
class ZodEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodEnum_cache.set(this, void 0);
  }
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache)) {
      __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values));
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache).has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
}
_ZodEnum_cache = /* @__PURE__ */ new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache)) {
      __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)));
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache).has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
}
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
}
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
class ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
class ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
class ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
class ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
class ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
}
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
class ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b2) {
    return new ZodPipeline({
      in: a,
      out: b2,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
({
  object: ZodObject.lazycreate
});
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const stringType = ZodString.create;
ZodNumber.create;
ZodNaN.create;
ZodBigInt.create;
ZodBoolean.create;
ZodDate.create;
ZodSymbol.create;
ZodUndefined.create;
ZodNull.create;
ZodAny.create;
ZodUnknown.create;
ZodNever.create;
ZodVoid.create;
ZodArray.create;
const objectType = ZodObject.create;
ZodObject.strictCreate;
ZodUnion.create;
ZodDiscriminatedUnion.create;
ZodIntersection.create;
ZodTuple.create;
ZodRecord.create;
ZodMap.create;
ZodSet.create;
ZodFunction.create;
ZodLazy.create;
ZodLiteral.create;
ZodEnum.create;
ZodNativeEnum.create;
ZodPromise.create;
ZodEffects.create;
ZodOptional.create;
ZodNullable.create;
ZodEffects.createWithPreprocess;
ZodPipeline.create;
const template = `<p> </p>
<div class="prehead" style="font-size: 0; max-height: 0;"> </div>
<table style="padding: 0px;" border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
        <tr>
            <td class="padsides2" bgcolor="#ffffff">
                <table class="container" style="margin: 0 auto;" border="0" width="650" cellspacing="0" cellpadding="0"
                    align="center">
                    <tbody>
                        <tr>
                            <td style="padding: 20px 0px;">
                                <table border="0" width="200" cellspacing="0" cellpadding="0" align="center">
                                    <tbody>
                                        <tr>
                                            <td><a href="https://www.payright.com.au/"><img class="mobwidth3"
                                                        style="max-width: 200px;"
                                                        src="https://payright.com.au/wp-content/uploads/logo-2.png"
                                                        alt="Payright" width="200" border="0" /></a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr class="container">
                                            <td><img class="img100" style="max-width: 650px;"
                                                    src="https://payright.com.au/wp-content/uploads/header1.png"
                                                    alt="Important information" width="650" border="0" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="paddingheight" style="font-size: 1px; line-height: 1px;" align="center"
                                bgcolor="#eff1f6" height="50"> </td>
                        </tr>
                        <tr>
                            <td bgcolor="#eff1f6">
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td class="mobwidth" width="50"> </td>
                                            <td>
                                                <table style="width: 100%;" border="0" width="100%" cellspacing="0"
                                                    cellpadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="textsmall"
                                                                style="font-family: Helvetica, Arial, 'Sans-serif'; font-size: 17px; line-height: 30px; color: #230050; text-align: left; width: 100%;">
                                                                <p><span style="font-size: 20px;"><strong>Hi
                                                                            {{customer_first_name}},</strong></span>
                                                                </p>
                                                                <p>Your payment for your Payright purchase
                                                                    was unsuccessful and remains unpaid.</p>
                                                                <p>Please log in to <a
                                                                        href="https://customerhub.payright.com.au/"
                                                                        target="_blank" rel="noreferrer noopener">your
                                                                        account</a> to make immediate payment.</p>
                                                                <p>You can also pay via the Payright app - available for
                                                                    download <a href="http://onelink.to/tvck45/"
                                                                        target="_blank"
                                                                        rel="noreferrer noopener">here</a>.</p>
                                                                <p>You can also pay immediately by clicking on the 
                                                                    pay now link <a href="{{pay_now_link}}"
                                                                        target="_blank"
                                                                        rel="noreferrer noopener">here</a>.</p>
                                                                <p>To speak with a Payright Collections Officer or if
                                                                    you are experiencing financial hardship please CALL
                                                                    US on 1300 338 496.<br /><br /><em>Thanks!<br />The
                                                                        Payright team</em></p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="paddingheight"
                                                                style="font-size: 1px; line-height: 1px; width: 100%;"
                                                                align="center" height="60"> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td class="mobwidth" width="50"> </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td bgcolor="#5431ff">
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td class="mobwidth" width="50"> </td>
                                            <td>
                                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="paddingheight"
                                                                style="font-size: 1px; line-height: 1px;" align="center"
                                                                height="50"> </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="textsmall"
                                                                style="font-family: Helvetica, Arial, 'Sans-serif'; font-size: 17px; line-height: 40px; color: #ffffff; text-align: left;">
                                                                <span class="textsmall2"
                                                                    style="font-size: 22px;"><strong>Right when you need
                                                                        it</strong></span><br />If you have any
                                                                questions, you can contact us at:</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="font-size: 1px; line-height: 1px;" align="center"
                                                                height="10"> </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="textsmall"
                                                                style="font-family: Helvetica, Arial, 'Sans-serif'; font-size: 17px; line-height: 30px; color: #ffffff; text-align: left;">
                                                                <strong>Payright Customer Support</strong><br />e: <a
                                                                    style="color: #ffffff; text-decoration: none;"
                                                                    href="mailto:admin@payright.com.au">admin@payright.com.au</a><br />a:
                                                                GPO Box 3491, Sydney, NSW 2001<br />p: 1300 338 496</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="paddingheight2"
                                                                style="font-size: 1px; line-height: 1px;" align="center"
                                                                height="0"> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td class="mobwidth" width="50"> </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td><img class="img100" style="max-width: 650px;"
                                    src="https://payright.com.au/wp-content/uploads/footer.png" alt="" width="650" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr class="container">
                                            <td style="font-size: 1px; line-height: 1px;" height="40"> </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <table border="0" width="292" cellspacing="0" cellpadding="0"
                                                    align="center">
                                                    <tbody>
                                                        <tr>
                                                            <td width="30"> </td>
                                                            <td><a href="https://www.facebook.com/Payrightaustralia/"><img
                                                                        style="max-width: 73px;"
                                                                        src="https://payright.com.au/wp-content/uploads/fb-1.png"
                                                                        alt="" width="36" border="0" /></a></td>
                                                            <td><a href="https://www.instagram.com/payright_au/?hl=en"><img
                                                                        style="max-width: 73px;"
                                                                        src="https://payright.com.au/wp-content/uploads/insta-1.png"
                                                                        alt="" width="36" border="0" /></a></td>
                                                            <td><a
                                                                    href="https://www.linkedin.com/company/payrightaustralia/?originalSubdomain=au"><img
                                                                        style="max-width: 73px;"
                                                                        src="https://payright.com.au/wp-content/uploads/in-1.png"
                                                                        alt="" width="36" border="0" /></a></td>
                                                            <td><a href="https://twitter.com/payright_au"><img
                                                                        style="max-width: 73px;"
                                                                        src="https://payright.com.au/wp-content/uploads/twitter-2.png"
                                                                        alt="" width="36" border="0" /></a></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bodylink"
                                                style="font-family: Helvetica, Arial, 'Sans-serif'; font-size: 14px; line-height: 22px; color: #240050; text-align: center; padding: 10px 0px;">
                                                <table border="0" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td class="mobwidth4" width="100"> </td>
                                                            <td class="bodylink"
                                                                style="font-family: Helvetica, Arial, 'Sans-serif'; font-size: 14px; line-height: 22px; color: #240050; text-align: center; padding: 20px 0px;">
                                                                <strong>Copyright © Navalo Financial Services Group Pty Ltd. All rights
                                                                    reserved.</strong><br /><br />GPO Box 3491, Sydney, NSW 2001</td>
                                                            <td class="mobwidth4" width="100"> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="30"> </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>`;
const PayNowLinkEmailDataSchema = objectType({
  customer_data: objectType({
    first_name: stringType(),
    email1: stringType().email()
  }),
  pay_now_link: stringType().url()
});
const payNowLinkEmailTemplateConfig = {
  PAY_NOW_LINK_EMAIL: {
    subject: "Pay now link",
    htmlTemplate: template,
    constructVariablesforTemplate: (data) => {
      var _a;
      const parsedData = PayNowLinkEmailDataSchema.parse(data);
      const payload = {
        customer_first_name: (_a = parsedData == null ? void 0 : parsedData.customer_data) == null ? void 0 : _a.first_name,
        pay_now_link: parsedData == null ? void 0 : parsedData.pay_now_link
      };
      return payload;
    },
    getToAddresses: (data) => {
      var _a;
      const parsedData = PayNowLinkEmailDataSchema.parse(data);
      return [(_a = parsedData == null ? void 0 : parsedData.customer_data) == null ? void 0 : _a.email1];
    }
  }
};
const planLoanFirstActivationEmailTemplate = ({
  merchantStore,
  plan,
  loan
}) => `<html>
  <p></p>
  <div class="prehead" style="font-size: 0; max-height: 0"> </div>
  <table style="padding: 0px" border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
      <tr>
        <td class="padsides2" bgcolor="#ffffff">
          <table
            class="container"
            style="margin: 0 auto"
            border="0"
            width="650"
            cellspacing="0"
            cellpadding="0"
            align="center"
          >
            <tbody>
              <tr>
                <td style="padding: 20px 0px">
                  <table border="0" width="200" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                      <tr>
                        <td>
                          <a href="https://www.payright.com.au/"
                            ><img
                              class="mobwidth3"
                              style="max-width: 200px"
                              src="https://payright.com.au/wp-content/uploads/logo-2.png"
                              alt="Payright"
                              width="200"
                              border="0"
                          /></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr class="container">
                        <td>
                          <img
                            class="img100"
                            style="max-width: 650px; display: block;"
                            src="https://payright.com.au/wp-content/uploads/header3.png"
                            airia-display="none"
                            width="650"
                            border="0"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  class="paddingheight"
                  style="font-size: 1px; line-height: 1px"
                  align="center"
                  bgcolor="#eff1f6"
                  height="50"
                >
                   
                </td>
              </tr>
              <tr>
                <td bgcolor="#eff1f6">
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td class="mobwidth" width="50"> </td>
                        <td>
                          <table
                            style="width: 100%"
                            border="0"
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr>
                                <td
                                  class="textsmall"
                                  style="
                                    font-family: Helvetica, Arial, 'Sans-serif';
                                    font-size: 17px;
                                    line-height: 30px;
                                    color: #230050;
                                    text-align: left;
                                    width: 100%;
                                  "
                                >
                                <strong>
                                  Details:
                                </strong>
                                <table style="border-collapse: collapse; width: 100%;" border="1">
                                    <tbody>
                                        <tr>
                                            <td style="width: 50%; text-align: left; padding: 6px;">Merchant Store</td>
                                            <td style="width: 50%; text-align: left; padding: 6px;">${merchantStore.name}</td>
                                        </tr>
                                        ${!loan ? "" : `
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Loan Id</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${loan.name}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Product Type</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${loan.type}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Loan Amount</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${formatCurrency(
  loan.amount
)}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Date Decisioned</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${loan.dateDecisioned}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Loan Activated</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${loan.dateActivated}</td>
                                          </tr>
                                          `}
                                        ${!plan ? "" : `
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Plan Id</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${plan.name}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Product Type</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${plan.type}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Plan Amount</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${formatCurrency(
  plan.amount
)}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Date Decisioned</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${plan.dateDecisioned}</td>
                                          </tr>
                                          <tr>
                                              <td style="width: 50%; text-align: left; padding: 6px;">Plan Activated</td>
                                              <td style="width: 50%; text-align: left; padding: 6px;">${plan.dateActivated}</td>
                                          </tr>
                                          `}
                                    </tbody>
                                </table>
                            
                                <p style="margin: 1em 0; line-height: 1.5">Please follow up your merchant with a congratulations and sense check the customer has received the benefit of their goods or service</p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="paddingheight"
                                  style="font-size: 1px; line-height: 1px; width: 100%"
                                  align="center"
                                  height="60"
                                ></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="mobwidth" width="50"> </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</html>`;
const rawApprovalEmailTemplate = `<html>
  <p> </p>
  <div class="prehead" style="font-size: 0; max-height: 0"> </div>
  <table style="padding: 0px" border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
      <tr>
        <td class="padsides2" bgcolor="#ffffff">
          <table
            class="container"
            style="margin: 0 auto"
            border="0"
            width="650"
            cellspacing="0"
            cellpadding="0"
            align="center"
          >
            <tbody>
              <tr>
                <td style="padding: 20px 0px">
                  <table border="0" width="200" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                      <tr>
                        <td>
                          <a href="https://www.payright.com.au/"
                            ><img
                              class="mobwidth3"
                              style="max-width: 200px"
                              src="https://payright.com.au/wp-content/uploads/logo-2.png"
                              alt="Payright"
                              width="200"
                              border="0"
                          /></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr class="container">
                        <td>
                          <img
                            class="img100"
                            style="max-width: 650px"
                            src="https://payright.com.au/wp-content/uploads/header1.png"
                            alt="Important information"
                            width="650"
                            border="0"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  class="paddingheight"
                  style="font-size: 1px; line-height: 1px"
                  align="center"
                  bgcolor="#eff1f6"
                  height="50"
                >
                   
                </td>
              </tr>
              <tr>
                <td bgcolor="#eff1f6">
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td class="mobwidth" width="50"> </td>
                        <td>
                          <table
                            style="width: 100%"
                            border="0"
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr>
                                <td
                                  class="textsmall"
                                  style="
                                    font-family: Helvetica, Arial, 'Sans-serif';
                                    font-size: 17px;
                                    line-height: 30px;
                                    color: #230050;
                                    text-align: left;
                                    width: 100%;
                                  "
                                >
                                  <p>
                                    <span style="font-size: 20px"
                                      ><strong>Hi {{ customer_first_name }},</strong></span
                                    >
                                  </p>
                                  <p>
                                    Your financial table and BNPL contract is attached.
                                  </p>
                                  <p style="font-style: italic;">Thanks!
                                    <br />
                                    The Payright team
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="paddingheight"
                                  style="font-size: 1px; line-height: 1px; width: 100%"
                                  align="center"
                                  height="60"
                                >
                                   
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="mobwidth" width="50"> </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td bgcolor="#5431ff">
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td class="mobwidth" width="50"> </td>
                        <td>
                          <table border="0" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr>
                                <td
                                  class="paddingheight"
                                  style="font-size: 1px; line-height: 1px"
                                  align="center"
                                  height="50"
                                >
                                   
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="textsmall"
                                  style="
                                    font-family: Helvetica, Arial, 'Sans-serif';
                                    font-size: 17px;
                                    line-height: 40px;
                                    color: #ffffff;
                                    text-align: left;
                                  "
                                >
                                  <span class="textsmall2" style="font-size: 22px"
                                    ><strong>Right when you need it</strong></span
                                  ><br />If you have any questions, you can contact us at:
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="font-size: 1px; line-height: 1px"
                                  align="center"
                                  height="10"
                                >
                                   
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="textsmall"
                                  style="
                                    font-family: Helvetica, Arial, 'Sans-serif';
                                    font-size: 17px;
                                    line-height: 30px;
                                    color: #ffffff;
                                    text-align: left;
                                  "
                                >
                                  <strong>Payright Customer Support</strong><br />e:
                                  <a
                                    style="color: #ffffff; text-decoration: none"
                                    href="mailto:admin@payright.com.au"
                                    >admin@payright.com.au</a
                                  ><br />a: GPO Box 3491, Sydney, NSW 2001<br />p: 1300
                                  338 496
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="paddingheight2"
                                  style="font-size: 1px; line-height: 1px"
                                  align="center"
                                  height="0"
                                >
                                   
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="mobwidth" width="50"> </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <img
                    class="img100"
                    style="max-width: 650px"
                    src="https://payright.com.au/wp-content/uploads/footer.png"
                    alt=""
                    width="650"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr class="container">
                        <td style="font-size: 1px; line-height: 1px" height="40"> </td>
                      </tr>
                      <tr>
                        <td>
                          <table
                            border="0"
                            width="292"
                            cellspacing="0"
                            cellpadding="0"
                            align="center"
                          >
                            <tbody>
                              <tr>
                                <td width="30"> </td>
                                <td>
                                  <a href="https://www.facebook.com/Payrightaustralia/"
                                    ><img
                                      style="max-width: 73px"
                                      src="https://payright.com.au/wp-content/uploads/fb-1.png"
                                      alt=""
                                      width="36"
                                      border="0"
                                  /></a>
                                </td>
                                <td>
                                  <a href="https://www.instagram.com/payright_au/?hl=en"
                                    ><img
                                      style="max-width: 73px"
                                      src="https://payright.com.au/wp-content/uploads/insta-1.png"
                                      alt=""
                                      width="36"
                                      border="0"
                                  /></a>
                                </td>
                                <td>
                                  <a
                                    href="https://www.linkedin.com/company/payrightaustralia/?originalSubdomain=au"
                                    ><img
                                      style="max-width: 73px"
                                      src="https://payright.com.au/wp-content/uploads/in-1.png"
                                      alt=""
                                      width="36"
                                      border="0"
                                  /></a>
                                </td>
                                <td>
                                  <a href="https://twitter.com/payright_au"
                                    ><img
                                      style="max-width: 73px"
                                      src="https://payright.com.au/wp-content/uploads/twitter-2.png"
                                      alt=""
                                      width="36"
                                      border="0"
                                  /></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="bodylink"
                          style="
                            font-family: Helvetica, Arial, 'Sans-serif';
                            font-size: 14px;
                            line-height: 22px;
                            color: #240050;
                            text-align: center;
                            padding: 10px 0px;
                          "
                        >
                          <table border="0" width="100%">
                            <tbody>
                              <tr>
                                <td class="mobwidth4" width="100"> </td>
                                <td
                                  class="bodylink"
                                  style="
                                    font-family: Helvetica, Arial, 'Sans-serif';
                                    font-size: 14px;
                                    line-height: 22px;
                                    color: #240050;
                                    text-align: center;
                                    padding: 20px 0px;
                                  "
                                >
                                  <strong
                                    >Copyright © Navalo Financial Services Group Pty Ltd. All rights
                                    reserved.</strong
                                  ><br /><br />GPO Box 3491, Sydney, NSW 2001
                                </td>
                                <td class="mobwidth4" width="100"> </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td height="30"> </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</html>
`;
const bnplApprovalEmailTemplate = ({ firstName }) => {
  const approvalEmailTemplate = handlebars.compile(rawApprovalEmailTemplate.toString());
  return approvalEmailTemplate({
    customer_first_name: firstName
  });
};
export {
  CreditContractTemplate,
  bnplApprovalEmailTemplate,
  b as bnplContractTemplate,
  customerStatementTemplate,
  loanStatementTemplate,
  payNowLinkEmailTemplateConfig,
  planLoanFirstActivationEmailTemplate
};
